// Complete translations for the entire website
export const translations = {
  zh: {
    nav: {
      home: "首页",
      services: "项目与研究",
      impact: "影响力",
      about: "关于",
      teams: "团队",
      joinUs: "加入我们",
      agentBi: "Agent BI",
      sillyDragon: "硅基龙宝",
      ai: "通用智能",
      forum: "信息",
      shopping: "发现本地商家",
      education: "教育服务",
      moreServices: "更多服务",
      creators: "社区达人",
      dating: "华人社交",
      legal: "法律帮助",
      ride: "叫车帮助",
      community: "互助合作",
      hr: "人力资源",
      membership: "成员",
      login: "登录",
      logout: "退出",
      dashboard: "控制台",
      careers: "加入我们",
      searchPlaceholder: "通用智能搜索...",
      moreToCome: "更多敬请期待",
      openMenu: "打开菜单",
      closeMenu: "关闭菜单",
    },
    common: {
      inDevelopment: "开发中",
      inDevelopmentDesc: "开发中，敬请期待",
      learnMore: "了解更多",
      experience: "体验",
      moreInfo: "了解更多",
      search: "搜索",
      clear: "清除",
      previous: "上一页",
      next: "下一页",
      page: "第 {num} 页",
      totalPosts: "共 {count} 条帖子",
      langSwitchEn: "Switch to English",
      langSwitchZh: "切换到中文",
    },
    home: {
      heroTitle: "华人社区AI",
      heroTagline: "为所有服务不足的社区普及AI与技术。",
      heroTaglineSmall: "从华人社区起步，优势与资源所在。",
      heroDescription:
        "我们于 2026 年启动。在 CCAI，我们的 AI 原生团队运用人工智能与技术赋能教育、信息获取、社区支持及更多。",
      heroDescription2: "我们也让华人社区和服务对更多人更易访问。",
      title: "华人社区AI - 您的智能社区入口",
      subtitle:
        "通过AI提供教育、信息获取与社区互助——学习、找资源、连接社区，一站支持。也让华人社区向更多人开放。使命驱动、非营利。",
      badge1: "进行中",
      badgeMvp: "MVP",
      badgeEarlyAccess: "抢先体验",
      badgePlanning: "规划中",
      badge2: "非营利组织，501c3申请中",
      servicesTitle: "服务",
      projectsTitle: "项目与研究（WIP）",
      impactTitle: "影响力",
      aboutTitle: "关于",
      teamsTitle: "团队",
      teamsSubtitle: "",
      peopleTitle: "团队",
      teamsCredibility:
        "我们的团队成员来自 Meta、Google、Amazon、Uber 等知名科技公司；我们的早期人才来自常春藤盟校等顶尖学府。",
      teamsViewAll: "查看全部",
      joinUsTitle: "加入我们",
      joinUsSubtitle: "",
      teams: {
        board: "理事会团队",
        boardMember0: { name: "Jiahong (Jahong) Liu", role: "创始人" },
        boardMember1: { name: "Joseph Venanzio", role: "理事兼首席技术官" },
        boardMember2: { name: "Hassan Mahamat", role: "理事兼首席安全官" },
        boardMember3: { name: "Ben Zheng", role: "理事兼首席运营与市场官" },
        boardMember4: { name: "Jiabei (Nicole) Liu", role: "理事兼AI软件工程师" },
        boardMember5: { name: "Mizo", role: "无表决权理事兼首席氛围官" },
        aiSoftwareEngineerTeam: "AI 软件工程师团队",
        aidTeam: "互助团队",
        dataTeam: "数据团队",
        marketingTeam: "市场/增长团队",
        securityTeam: "负责任 AI 与安全团队",
        legalTeam: "法务团队",
        uiuxTeam: "UI/UX 团队",
        hrTeam: "人力资源团队",
        productTeam: "产品团队",
        mentorsTeam: "顾问 / 导师团队",
      },
      teamMembers: {
        aiSoftwareEngineerTeam: [
          { name: "Zhijie Yan", role: "AI 软件工程师" },
          { name: "Kehan Xiao", role: "AI 软件工程师" },
          { name: "HanYang (Eric) Zheng", role: "AI 软件工程师" },
          { name: "Fiona Li", role: "AI 软件工程师" },
          { name: "Peiwen Zhong", role: "AI 软件工程师" },
          { name: "Eltayeb E", role: "项目经理" },
          { name: "Niki Mai", role: "项目经理" },
        ],
        legalTeam: [{ name: "Yangqing Zhang", role: "法律顾问" }],
        marketingTeam: [
          { name: "Ben Zheng", role: "理事兼首席运营与市场官" },
          { name: "Yitong Liang", role: "市场营销专员" },
        ],
        dataTeam: [
          { name: "Libin (Peter) Chen", role: "数据科学家" },
          { name: "Yiting Wang", role: "数据科学家" },
        ],
        aidTeam: [],
        securityTeam: [
          { name: "Robert Maina", role: "首席信息安全官" },
          { name: "Benson Jengela", role: "信息安全工程师" },
          { name: "Joel Nyirongo", role: "信息安全工程师" },
          { name: "Mahdi Alajmi", role: "信息安全工程师" },
        ],
        mentorsTeam: [
          { name: "Yue (Amanda) Yao", role: "内容顾问" },
          { name: "Anqi Nie", role: "技术顾问" },
          { name: "Sean Galvan", role: "健康顾问" },
          { name: "Hadi Jaber", role: "对外关系与合作顾问" },
          { name: "Xuxin (Peter) Han", role: "技术顾问" },
          { name: "Xingdong (Sheldon) Li", role: "技术顾问" },
          { name: "Zichong Meng", role: "研究顾问" },
        ],
        uiuxTeam: [
          { name: "Jiajia (Cindy) Chen", role: "UI/UX 设计师" },
        ],
        hrTeam: [{ name: "Xinyan Lin", role: "人力资源" }],
        productTeam: [
          { name: "Jiajia (Cindy) Chen", role: "产品经理" },
          { name: "Eliana You", role: "产品经理" },
        ],
      },
      servicesSubtitle:
        "AI驱动的教育与社区服务，支持信息获取、科技素养与社区互助",
      moreServicesToCome: "更多服务敬请期待",
      moreServicesToComeDesc: "我们正在持续开发新功能，敬请关注。",
      moreProjectsToCome: "更多项目敬请期待",
      moreProjectsToComeDesc: "我们正在持续开发新功能，敬请关注。",
      stats: {
        traffic: "跨平台流量",
        fans: "跨平台粉丝",
        merchants: "社区合作伙伴",
        financialSupport: "贡献给社区的资金",
        earlyTalent: "早期人才辅导",
        volunteers: "参与的工作者/志愿者",
        communityMembers: "社区成员",
        andCounting: "持续增加中",
      },
      mission: {
        title: "我们的使命",
        description: "",
        vision: "非营利组织，回馈社区。",
        goal: "愿景：海外华人及所有人的AI智能社区服务平台",
        brandName: "华人社区AI",
      },
      problems: {
        title: "传统平台的问题",
        items: [
          "信息过载，难以找到有用信息",
          "商业为导向，忽略华人社区需求",
          "移民与少数族裔面临数字鸿沟",
        ],
      },
      solutions: {
        title: "我们的解决方案",
        items: [
          "AI驱动的精准搜索与信息获取，帮助完成学习与生活任务",
          "以社区需求为先，服务资源不足的华人社区及更多",
          "连接社区资源与信息，促进数字包容与科技素养，并向所有人开放社区资源",
        ],
      },
      features: {
        agentBi: {
          title: "Agent BI",
          description:
            "将 Agentforce / Salesforce 类产品普及给非营利组织和华人小企业，用智能与数据赋能公益。人类与智能体一起，推动成功。利用 Superset 等开源资源。",
        },
        ai: {
          title: "通用智能",
          description:
            "AI驱动的精准搜索和通用AI助手。一个指令帮你完成需要的任务，告别信息过载，享受智能体验。",
          comingSoon: "即将推出",
          tagline: "一个指令完成任何任务——搜索、对话、创作等。",
          searchPlaceholder: "你想做什么？告诉我你的需求…",
        },
        forum: {
          title: "信息",
          description:
            "连接华人社区的长者、新移民和学生。分享经验，建立友谊，共同成长。",
        },
        shopping: {
          title: "发现本地商家",
          description: "发现并连接本地华人商家，支持购物与配送一站式服务。",
        },
        legal: {
          title: "法律帮助",
          description:
            "专业的法律咨询与帮助，协助新移民和社区成员解决法律问题。",
        },
        education: {
          title: "教育服务",
          description:
            "互动式AI老师，让教育触手可及；优质课程涵盖软件工程、数据科学与职业发展。",
        },
        community: {
          title: "互助合作",
          description: "与社区合作，让所有互助服务更易获取。",
        },
        health: {
          title: "健康",
          description: "用AI技术为医疗资源薄弱社区普及健康辅助。",
        },
        sillyDragon: {
          title: "通用AI - 硅基龙宝",
          description: "普及能真正替你完成任务的AI助手。",
        },
        ride: {
          title: "叫车帮助",
          description:
            "AI智能叫车帮助，自动匹配最优路线和司机，让您的出行更加便捷安全。",
        },
      },
    },
    legal: {
      title: "法律帮助",
      subtitle: "专业的法律咨询与帮助",
      description: "协助新移民和社区成员解决法律问题，提供法律咨询与帮助。",
      inDevelopment: "开发中，敬请期待",
      aiAssistantTitle: "AI法律助手",
      aiAssistantSubtitle: "24/7在线，快速解答您的法律问题",
      onlineConsult: "在线咨询",
      startChat: "立即开始对话",
      service247: "24/7服务",
      anytime: "随时为您服务",
      quickResponse: "快速响应",
      secondsReply: "秒级回复",
      tryAiAssistant: "立即体验AI法律助手",
      howItWorks: "服务流程",
      step1Title: "提交咨询",
      step1Desc: "填写咨询表单或直接联系我们，描述您的法律需求",
      step2Title: "专业评估",
      step2Desc: "我们的律师团队会评估您的情况，并提供专业建议",
      step3Title: "解决方案",
      step3Desc: "制定解决方案，协助您处理法律事务，保护您的权益",
      lawFirmsTitle: "合作律所（非真实信息，目前只是参考样本）",
      lawFirmsIntro:
        "如需专业律师服务，我们与多家知名华人律所合作，为社区提供专业法律服务",
      yearsInPractice: "执业 {years} 年",
      rating: "评分",
      specialtiesLabel: "专业领域：",
      contactFirm: "联系律所",
      whyChooseUs: "为什么选择我们",
      proTeam: "专业团队",
      proTeamDesc: "经验丰富的华人律师团队",
      privacy: "隐私保护",
      privacyDesc: "严格保护客户隐私和信息安全",
      fastResponse: "快速响应",
      fastResponseDesc: "24小时内响应您的咨询需求",
      transparentPricing: "透明定价",
      transparentPricingDesc: "清晰的服务价格，无隐藏费用",
      contactFormTitle: "在线咨询",
      nameLabel: "姓名 *",
      namePlaceholder: "请输入您的姓名",
      emailLabel: "邮箱 *",
      emailPlaceholder: "请输入您的邮箱",
      messageLabel: "咨询内容 *",
      messagePlaceholder: "请详细描述您的法律问题或需求...",
      submitConsult: "提交咨询",
      faqTitle: "常见问题",
      faq1Q: "咨询费用如何计算？",
      faq1A:
        "我们提供透明的定价服务。初次咨询通常免费，具体服务费用根据案件复杂程度而定。所有费用会在服务开始前明确告知，不会产生隐藏费用。",
      faq2Q: "需要多长时间才能得到回复？",
      faq2A:
        "我们承诺在24小时内响应您的咨询。紧急情况可以优先处理。具体处理时间取决于案件的复杂程度和所需准备工作。",
      faq3Q: "可以远程咨询吗？",
      faq3A:
        "是的，我们支持电话、视频和在线咨询。对于需要面对面处理的情况，我们可以在纽约地区提供上门服务。",
      faq4Q: "你们的律师资质如何？",
      faq4A:
        "我们的律师团队均持有美国律师执照，拥有丰富的华人社区法律服务经验，熟悉移民、房产、商业等各类法律事务。",
      lawFirms: [
        {
          name: "纽约华美律师事务所",
          specialties: ["移民签证", "商业法律", "房产租赁"],
          location: "纽约曼哈顿",
          phone: "(212) 555-0100",
          email: "info@huameilaw.com",
          rating: "4.9",
          description: "专业服务华人社区20余年，擅长移民、商业和房产法律事务",
          years: "20+",
        },
        {
          name: "法拉盛联合律师事务所",
          specialties: ["移民签证", "家庭法律", "就业法律"],
          location: "纽约法拉盛",
          phone: "(718) 555-0200",
          email: "contact@flushinglaw.com",
          rating: "4.8",
          description: "专注服务新移民，提供全方位的法律咨询和服务",
          years: "15+",
        },
        {
          name: "洛杉矶太平洋律师事务所",
          specialties: ["商业法律", "知识产权", "合同起草"],
          location: "洛杉矶",
          phone: "(323) 555-0300",
          email: "info@pacificlaw.com",
          rating: "4.9",
          description: "为华人企业提供专业的商业法律服务和咨询",
          years: "18+",
        },
        {
          name: "旧金山湾区律师事务所",
          specialties: ["移民签证", "房产租赁", "家庭法律"],
          location: "旧金山",
          phone: "(415) 555-0400",
          email: "info@baylaw.com",
          rating: "4.7",
          description: "服务湾区华人社区，经验丰富的律师团队",
          years: "12+",
        },
        {
          name: "芝加哥中西部律师事务所",
          specialties: ["商业法律", "移民签证", "就业法律"],
          location: "芝加哥",
          phone: "(312) 555-0500",
          email: "contact@midwestlaw.com",
          rating: "4.8",
          description: "为中西部华人社区提供专业法律服务",
          years: "10+",
        },
        {
          name: "波士顿新英格兰律师事务所",
          specialties: ["家庭法律", "移民签证", "房产租赁"],
          location: "波士顿",
          phone: "(617) 555-0600",
          email: "info@newenglandlaw.com",
          rating: "4.9",
          description: "服务新英格兰地区华人，专业的法律团队",
          years: "14+",
        },
      ],
    },
    community: {
      title: "互助合作",
      inDevelopment: "开发与规划中",
      pageSummary:
        "本计划仍在开发与规划阶段，具体服务形态与名单将陆续确定。",
      examplesNote: "具体服务与名单仍在规划中，以上仅为示例。",
      subtitle: "免费服务，让社区更温暖",
      description:
        "与社区合作，让所有互助服务更易获取。",
      missionTitle: "我们的使命",
      missionDesc:
        "建设温暖、团结、互助的华人社区，所有服务100%免费。",
      freeService: "免费服务",
      communityPartners: "社区伙伴",
      localPartners: "本地合作",
      missionDriven: "使命驱动",
      serveCommunity: "服务华人社区",
      freeServicesTitle: "免费服务示例",
      servicesSection: "服务项目",
      foundServices: "找到 {count} 项免费服务",
      free: "免费",
      viewAll: "查看全部",
      upcomingEvents: "即将举行的活动",
      learnMore: "了解详情",
      howToParticipate: "如何参与",
      becomeVolunteer: "成为志愿者",
      volunteerDesc: "用时间与技能帮助社区成员",
      volunteerCta: "申请成为志愿者",
      donate: "捐赠支持",
      donateDesc: "捐赠100%用于社区服务",
      donateCta: "立即捐赠",
      seekHelp: "寻求帮助",
      seekHelpDesc: "需要帮助可联系我们，我们将尽力协助",
      seekHelpCta: "寻求帮助",
      contactUs: "联系我们",
      emailContact: "邮件联系",
      phoneContact: "电话联系",
      valuesTitle: "我们的价值观",
      unity: "团结",
      unityDesc: "华人社区团结一致，互相支持",
      mutualAid: "互助",
      mutualAidDesc: "帮助他人就是帮助自己",
      trust: "信任",
      trustDesc: "建立可信赖的社区环境",
      growth: "成长",
      growthDesc: "共同成长，共同进步",
      categories: [
        "全部",
        "生活服务",
        "心理健康",
        "教育培训",
        "健康医疗",
        "其他",
      ],
      services: [
        {
          title: "免费午餐",
          description: "为需要帮助的社区成员提供免费营养午餐，每周一至周五开放",
          location: "待定",
          time: "待定",
          category: "生活服务",
        },
        {
          title: "免费心理咨询",
          description:
            "专业心理咨询师提供免费心理健康咨询服务，帮助应对生活压力",
          location: "待定",
          time: "待定",
          category: "心理健康",
        },
        {
          title: "免费法律援助",
          description: "为低收入社区成员提供免费法律咨询和援助服务",
          location: "待定",
          time: "待定",
          category: "其他",
        },
        {
          title: "免费英语课程",
          description: "为新移民提供免费英语学习课程，帮助适应美国生活",
          location: "待定",
          time: "待定",
          category: "教育培训",
        },
        {
          title: "免费健康检查",
          description: "定期提供免费健康体检和医疗咨询服务",
          location: "待定",
          time: "待定",
          category: "健康医疗",
        },
        {
          title: "免费就业指导",
          description: "提供简历修改、面试技巧、职业规划等免费就业支持",
          location: "待定",
          time: "待定",
          category: "教育培训",
        },
        {
          title: "免费生活用品",
          description: "为有需要的家庭提供免费生活用品和食物",
          location: "待定",
          time: "待定",
          category: "生活服务",
        },
        {
          title: "免费翻译服务",
          description: "提供中英文翻译服务，帮助解决语言沟通问题",
          location: "待定",
          time: "待定",
          category: "其他",
        },
        {
          title: "免费老人关爱",
          description: "为社区长者提供陪伴、聊天和心理支持服务",
          location: "待定",
          time: "待定",
          category: "心理健康",
        },
        {
          title: "免费税务咨询",
          description: "为低收入家庭提供免费报税和税务咨询服务",
          location: "待定",
          time: "待定",
          category: "其他",
        },
        {
          title: "免费儿童辅导",
          description: "为学龄儿童提供免费课后辅导和学习支持",
          location: "待定",
          time: "待定",
          category: "教育培训",
        },
        {
          title: "免费健康讲座",
          description: "定期举办免费健康知识讲座，提升社区健康意识",
          location: "待定",
          time: "待定",
          category: "健康医疗",
        },
      ],
      events: [
        {
          title: "免费社区午餐活动",
          date: "2026-01-20",
          location: "待定",
          description: "为社区成员提供免费营养午餐，欢迎参加。",
          type: "生活服务",
        },
        {
          title: "心理健康讲座",
          date: "2026-01-18",
          location: "待定",
          description: "专业心理咨询师分享心理健康知识，免费参加。",
          type: "心理健康",
        },
        {
          title: "免费英语角",
          date: "2026-01-15",
          location: "待定",
          description: "练习英语口语，结交新朋友，完全免费。",
          type: "教育培训",
        },
        {
          title: "免费健康义诊",
          date: "2026-01-25",
          location: "待定",
          description: "免费健康检查和医疗咨询，关注社区健康。",
          type: "健康医疗",
        },
      ],
    },
    ride: {
      title: "叫车帮助",
      subtitle: "AI智能叫车帮助",
      description: "自动匹配最优路线和司机，让您的出行更加便捷安全。",
      inDevelopment: "开发中，敬请期待",
      pickupLabel: "出发地",
      destinationLabel: "目的地",
      pickupPlaceholder: "输入出发地址或选择当前位置",
      destinationPlaceholder: "输入目的地地址",
      departureTimeLabel: "出发时间",
      passengersLabel: "乘客人数",
      departureNow: "现在出发",
      departureLater: "稍后出发",
      departureTomorrow: "预约明天",
      passengersCount: "{n}人",
      passengers5Plus: "5人以上",
      matchButton: "AI智能匹配叫车",
      chooseVehicleTitle: "选择车型",
      futureTechTitle: "未来AI技术",
      futureTechDesc: "智能出行，让每一次旅程都更完美",
      routeOptimization: "AI路线优化",
      routeOptimizationDesc: "实时分析交通状况，自动选择最优路线，节省时间",
      smartDispatch: "智能调度",
      smartDispatchDesc: "AI预测需求，提前调度车辆，减少等待时间",
      safeSmart: "安全智能",
      safeSmartDesc: "AI实时监控，确保行程安全，让您安心出行",
      whyChooseTitle: "为什么选择我们",
      autoDrive: "自动驾驶",
      autoDriveDesc: "未来AI自动驾驶车辆，无需司机，安全舒适",
      comingSoon: "即将推出",
      aiRide: "AI智能叫车",
      aiRideDesc: "AI自动匹配最优路线和司机，智能调度，最快到达",
      economy: "经济型",
      economyDesc: "经济实惠的出行选择",
      comfort: "舒适型",
      comfortDesc: "更宽敞舒适的车内空间",
      luxury: "豪华型",
      luxuryDesc: "高端车型，尊享体验",
      featureAuto: "自动驾驶",
      featureNav: "AI导航",
      featureSafe: "安全可靠",
      featureFuture: "未来科技",
      featureRoute: "AI路线优化",
      featureMatch: "智能匹配",
      featureTrack: "实时追踪",
      featureBudget: "经济实惠",
      featureFast: "快速到达",
      featureSeat: "舒适座椅",
      featureSpace: "更多空间",
      featureCar: "豪华车型",
      featureDriver: "专业司机",
      devNote: "我们正在开发更先进的AI技术，让叫车帮助更加智能和便捷",
      futureNote:
        "我们正在与领先的自动驾驶技术公司合作，预计在未来几年内推出完全自动驾驶的叫车帮助，让您的出行更加安全、便捷和环保",
    },
    creators: {
      title: "社区达人",
      heroTitle: "更好的华人UGC，从更好的达人开始",
      heroDesc:
        "跳过冷启动，直连高质量华人创作者。我们用AI理解品牌需求与内容风格，匹配擅长短视频与转化内容的达人，提升投放效率与内容质量。",
      publishRequest: "发布需求",
      becomeCreator: "成为达人",
      flowTitle: "合作流程",
      steps: [
        {
          title: "发布需求",
          description: "告诉我们需要的创作者数量、目标人群与内容方向。",
        },
        {
          title: "查看匹配",
          description: "审核达人资料、数据表现与过往作品，快速完成筛选。",
        },
        {
          title: "开始合作",
          description: "与达人对接需求，快速交付高质量UGC内容。",
        },
      ],
      featuredTitle: "精选达人",
      featuredSubtitle: "审核入驻 · 数据可见",
      founderBadge: "创作者驱动平台",
      founderTitle: "平台由达人共同打造",
      founderDesc:
        "通过创作者网络与AI匹配系统，我们为品牌提供高质量UGC创作能力，减少试错成本，并让匹配与协作更高效。",
      creatorScore: "创作者评分",
      creatorScoreDesc: "覆盖多平台短视频与带货场景",
      pricingTitle: "定价",
      pricingCustom: "按需求定制",
      pricingFlexible: "灵活方案",
      pricingItem1: "依据预算与周期匹配达人",
      pricingItem2: "完整达人资料、数据与报价",
      pricingItem3: "从需求到交付的协助支持",
      getPlan: "获取方案",
    },
    membership: {
      title: "成为社区成员",
      subtitle: "支持华人社区平台，免费享受所有服务",
      description:
        "成员费用于维持平台运营，支持教育与社区服务。非营利组织，回馈社区。",
      cardTitle: "社区成员",
      price: "/月",
      priceDesc: "支持华人社区平台发展",
      benefitsTitle: "成员权益",
      benefits: [
        "免费享受平台所有服务",
        "优先获得新功能体验",
        "专属客服支持",
        "参与社区决策",
        "支持华人社区发展",
      ],
      serviceTitle: "成员可享受的服务",
      joinButton: "立即加入",
      whyTitle: "为什么成为成员？",
      whyItems: [
        {
          title: "支持社区",
          description: "您的支持帮助平台持续为华人社区提供服务",
        },
        {
          title: "免费服务",
          description: "成员可以免费使用平台上的所有服务",
        },
        {
          title: "优先体验",
          description: "优先获得新功能和服务的体验机会",
        },
        {
          title: "社区参与",
          description: "参与社区决策，共同建设更好的华人社区平台",
        },
      ],
      modelTitle: "成员模式说明",
      modelDesc: "成员费用于支持平台运营与服务发展",
      modelItems: [
        {
          title: "社区支持",
          description: "成员费用于平台运营与社区服务的持续优化",
        },
        {
          title: "免费服务",
          description:
            "成员可免费使用平台上的教育、论坛、AI助手、法律信息与社区互助等服务",
        },
        {
          title: "培训招聘",
          description: "为华人提供职业培训与招聘服务，帮助华人就业与职业发展",
        },
        {
          title: "持续发展",
          description: "成员费用于平台运营与服务能力提升",
        },
      ],
      missionTitle: "我们的使命",
      missionDesc:
        "我们致力于为华人社区提供教育与信息服务，连接社区成员与教育资源。",
      missionPlatform: "平台模式",
      missionPlatformDesc:
        "我们提供教育与社区服务平台，支持科技素养、信息获取与社区互助。",
      missionRevenue: "收益用途",
      missionRevenueDesc:
        "成员费用于平台运营与教育、社区服务。支持职业培训与社区项目，帮助华人就业与融入。",
      faqTitle: "常见问题",
      faq: [
        {
          question: "成员费是什么性质的费用？",
          answer:
            "成员费是平台服务支持费用，用于支持平台运营和发展。成员可以免费使用平台上的所有服务。",
        },
        {
          question: "成员费如何使用？",
          answer:
            "成员费用于平台运营成本（服务器、维护、团队等），并用于产品与服务持续优化。",
        },
        {
          question: "成员可以享受哪些服务？",
          answer:
            "成员可免费使用平台上的通用智能、社区论坛、教育服务、法律信息与社区互助等服务。",
        },
        {
          question: "可以随时取消成员吗？",
          answer:
            "是的，您可以随时取消成员。取消后，您将无法继续使用需要成员的服务。",
        },
      ],
      ctaTitle: "准备加入了吗？",
      ctaDesc: "成为社区成员，支持华人社区平台，免费享受所有服务",
      ctaButton: "立即成为成员",
    },
    login: {
      title: "登录",
      registerTitle: "注册",
      welcome: "欢迎回来",
      joinTitle: "加入华人社区AI平台",
      email: "邮箱",
      usernameOrEmail: "用户名或邮箱",
      username: "用户名",
      password: "密码",
      confirmPassword: "确认密码",
      passwordPlaceholder: "密码",
      confirmPasswordPlaceholder: "再次输入密码",
      submit: "登录",
      register: "注册",
      processing: "处理中...",
      noAccount: "还没有账号？立即注册",
      hasAccount: "已有账号？立即登录",
      passwordMismatch: "密码不匹配",
      operationFailed: "操作失败，请稍后重试",
    },
    forum: {
      title: "社区论坛",
      categories: "论坛分类",
      recentPosts: "最新帖子",
      allPosts: "全部帖子",
      threads: "主题",
      posts: "帖子",
      pinned: "置顶",
      uncategorized: "未分类",
      anonymous: "匿名",
      reply: "回复",
      views: "浏览",
      minutesAgo: "分钟前",
      hoursAgo: "小时前",
      daysAgo: "天前",
      createPost: "发布新帖",
      searchPlaceholder: "搜索帖子...",
      noPosts: "暂无帖子，快来发第一个帖子吧！",
      loading: "加载中...",
      searchResults: "搜索结果",
      categoryPosts: "分类帖子",
      showAll: "显示全部",
      noSearchResults: "没有找到相关帖子",
      noRecentPosts: "暂无最新帖子",
      announcementsTitle: "站内公告",
      subtitle: "连接华人社区，分享生活经验，建立友谊，共同成长",
      announcements: [
        "华人社区AI平台 2026 年新版论坛上线，欢迎体验！",
        "社区活动：本周末唐人街文化节，欢迎大家参与",
        "论坛规则更新：请文明发言，共建和谐社区",
      ],
      categoriesList: [
        { name: "房屋租售", description: "租房、买房、卖房、房屋维修等信息" },
        { name: "求职招聘", description: "工作机会、招聘信息、求职经验分享" },
        { name: "美食推荐", description: "餐厅推荐、美食分享、食谱交流" },
        { name: "二手交易", description: "闲置物品转让、求购信息" },
        { name: "生活服务", description: "便民服务、生活求助、社区互助" },
        { name: "社区活动", description: "社区活动、聚会、文化交流" },
      ],
    },
    postDetail: {
      backToForum: "返回论坛",
      loading: "加载中...",
      notFound: "帖子不存在",
      edit: "编辑",
      delete: "删除",
      deleteConfirm: "确定要删除这个帖子吗？",
      deleteFailed: "删除失败，请稍后重试",
      views: "浏览",
      replies: "回复",
      replyTitle: "回复",
      replyPlaceholder: "写下你的回复...",
      submitReply: "发布回复",
      submitting: "发布中...",
      replyFailed: "发布回复失败，请稍后重试",
      noReplies: "暂无回复，快来抢沙发吧！",
      anonymous: "匿名",
      loginToReply: "请{login}后回复",
    },
    createPost: {
      backToForum: "返回论坛",
      title: "发布新帖子",
      selectCategory: "选择分类",
      postTitle: "标题",
      titlePlaceholder: "请输入帖子标题...",
      content: "内容",
      contentPlaceholder: "写下你想分享的内容...",
      cancel: "取消",
      submit: "发布帖子",
      submitting: "发布中...",
      submitFailed: "发布失败，请稍后重试",
      loading: "加载中...",
    },
    about: {
      title: "我们的使命",
      body: "我们于2026年启动。在CCAI，我们的AI原生团队运用人工智能和技术赋能教育、信息获取、社区支持及更多。我们也让华人社区和服务对每个人更易获取。",
      stats: {
        youtube: "YouTube观看量",
        tiktok: "TikTok粉丝",
        merchants: "社区合作伙伴",
      },
      problemsTitle: "传统平台的问题",
      problems: [
        "信息过载，难以找到有用信息",
        "商业为导向，忽略华人社区需求",
        "移民与少数族裔面临数字鸿沟与信息获取障碍",
        "缺乏面向社区的教育与科技素养支持",
      ],
      solutionsTitle: "我们的解决方案",
      solutions: [
        "AI驱动的信息搜索与教育工具，支持学习与生活",
        "以社区需求为先，服务资源不足的华人社区及更多",
        "促进科技素养与数字包容，连接社区资源与信息，并向所有人开放社区资源",
        "提供教育与社区服务，助力移民融入与成长",
      ],
      visionTitle: "我们的愿景",
      visionDesc: "成为海外华人的AI智能社区服务平台",
      stages: [
        {
          stage: "阶段一",
          title: "聚焦纽约唐人街/法拉盛",
          desc: "服务长者、新移民和学生",
        },
        {
          stage: "阶段二",
          title: "覆盖全美华人社区",
          desc: "扩展到所有美国华人社区",
        },
        {
          stage: "阶段三",
          title: "服务全球华人",
          desc: "成为全球华人的AI智能入口",
        },
      ],
      advantagesTitle: "我们的优势",
      advantages: [
        { title: "AI驱动", desc: "运用AI技术提供教育与信息获取服务" },
        { title: "使命驱动", desc: "以社区教育与数字包容为导向" },
        { title: "文化深度", desc: "深度理解华人社区文化与需求" },
        { title: "社区优先", desc: "助力移民与少数族裔跨越数字鸿沟" },
      ],
      whyNowTitle: "为什么是现在？",
      whyNowDesc:
        "许多移民与华人社区成员面临语言障碍、信息获取困难和数字鸿沟。我们相信，通过AI与教育技术，可以连接被忽视的社区成员，促进科技素养与社区融合，帮助他们在数字时代获得信息与机会。",
      joinUs: "如果你有相同的愿景和使命，欢迎加入我们！",
      contactTitle: "联系我们",
      contactDesc: "我们会尽快与您联系。",
      sendResumeTo: "发送简历至",
    },
    agentBiPage: {
      title: "Agent BI",
      body: "我们将 Agentforce / Salesforce 类产品普及给非营利组织和华人小企业，用智能与数据赋能公益。人类与智能体一起，推动成功。利用 Superset 等开源资源。",
      backToProjects: "返回项目与研究",
      videoUnsupported: "您的浏览器不支持播放此视频。",
      videoLoadHint: "请将视频文件放入 public/videos/，命名为 agent-bi-demo.mp4 或 agent-bi-demo.mov。",
    },
    sillyDragonPage: {
      title: "硅基龙宝",
      body: "我们正在打造首例硅基生命——硅基龙宝，能真正替你完成任务。我们努力让产品极易上手，即便没有技术背景也能轻松使用。长远目标是构建足以帮助、支撑整个华人社区的超强人工智能，但我们会从可落地的步骤做起；先推出 AI 助手的测试版，让你抢先体验未来的方向。",
      earlyAccessTitle: "抢先版",
      earlyAccessIntro: "抢先版对非技术用户非常友好，让每个人都能轻松体验 AI 智能体。",
      earlyAccessBullet1: "一键下载",
      earlyAccessBullet2: "通过 Telegram、WhatsApp 等直接对话",
      earlyAccessBullet3: "在日历中查看计划中的定时任务",
      earlyAccessBullet4: "像管理游戏伙伴一样管理 AI 智能体技能",
      backToProjects: "返回项目与研究",
      videoUnsupported: "您的浏览器不支持播放此视频。",
      videoLoadHint: "请将视频文件放入 public/videos/，命名为 silly-dragon-demo.mp4（推荐）或 silly-dragon-demo.mov。",
      aboutTitle: "后续版本",
      aboutSubtitle: "硅基龙蛋 — 硅基生命孵化中",
      aboutBrain: "大脑：借大厂LLM，计划自研",
      aboutClaw: "爪子：OpenClaw；自研龙爪中",
      aboutEye: "眼睛：画龙点睛CV项目启动中",
      aboutEar: "耳朵：计划随身便携装置比如别针，戒指",
      aboutBody: "身子：寻机器人厂商合作赞助",
      aboutVersion: "版本 0.2.1",
      download: "下载抢先版",
      downloadModalTitle: "确认下载",
      downloadModalDetected: "检测到您的设备：",
      downloadModalConfirm: "确认下载",
      downloadModalCancel: "取消",
      deviceMacAppleSilicon: "Mac（Apple Silicon）",
      deviceMacIntel: "Mac（Intel）",
      deviceWindows64: "Windows（64 位）",
      deviceWindowsArm64: "Windows（ARM64）",
      deviceOther: "其他设备",
      downloadOtherMessage: "请前往发布页下载 Linux 或其他平台版本。",
    },
    forumIntroPage: {
      title: "社区论坛 + AI 匹配",
      body: "不少传统论坛类网站以营利和设限为主，很多有用信息被挡在门外。我们正在打造一个完全免费的论坛，让每个人都能分享信息、互帮互助。我们还会用 AI 帮你匹配你需要的伙伴——无论是求助、建议、职业咖啡聊，还是更多场景。",
      backToProjects: "返回项目与研究",
      goToForum: "进入论坛",
      image1Alt: "华人社区与 AI 服务入口",
      image2Alt: "论坛分类",
    },
    education: {
      mvpBanner: "STEM MVP: 计算机科学 / AI 方向最小可行产品测试地址：",
      title: "让教育触手可及",
      inDevelopment: "开发中，敬请期待",
      subtitle: "用互动式AI老师，让每个人都能获得优质教育",
      description:
        "从初级到高级，我们通过互动式AI老师为华人社区及所有人提供可及的教育资源。",
      aiFeature: {
        badge: "AI智能教育",
        title: "互动式AI老师，让教育触手可及",
        description:
          "用互动式AI老师重新定义学习。个性化课程、智能答疑、实时反馈，让每一分钟的学习都更有价值。",
        cta: "立即体验",
      },
      introImageAlt: "AI 互动课堂与课程平台",
      popularCourses: "热门课程",
      foundCourses: "找到",
      courses: "门课程",
      learnMore: "了解更多 →",
      categories: [
        "全部",
        "语言学习",
        "软件工程与IT",
        "商业",
        "数据科学",
        "服务业",
      ],
      levels: {
        beginner: "初级",
        intermediate: "中级",
        advanced: "高级",
      },
      coursesList: [
        {
          title: "英语学习",
          description:
            "从零基础到流利交流，全面提升英语听说读写能力，帮助新移民快速适应美国生活和工作。",
          category: "语言学习",
        },
        {
          title: "软件工程师",
          description:
            "全栈开发技能，掌握前端、后端、数据库等核心技术，成为专业的软件工程师。",
          category: "软件工程与IT",
        },
        {
          title: "数据科学家",
          description:
            "数据分析、机器学习、AI技术，掌握数据科学的核心技能，成为炙手可热的数据专家。",
          category: "数据科学",
        },
        {
          title: "项目经理",
          description:
            "项目规划、团队管理、风险管理等核心技能，成为优秀的项目经理。",
          category: "商业",
        },
        {
          title: "UX设计师",
          description: "用户体验设计、界面设计、交互设计，打造出色的产品体验。",
          category: "软件工程与IT",
        },
        {
          title: "厨师",
          description:
            "中餐烹饪技巧、西餐基础、食品安全，掌握专业厨艺，开启餐饮事业。",
          category: "服务业",
        },
        {
          title: "会计师",
          description: "财务会计、税务筹划、审计技能，成为专业的会计人才。",
          category: "商业",
        },
        {
          title: "数据分析师",
          description: "Excel、SQL、数据可视化，掌握数据分析的核心工具和技能。",
          category: "数据科学",
        },
        {
          title: "市场营销/增长",
          description: "数字营销、社交媒体营销、内容营销、增长策略，掌握现代营销技能。",
          category: "商业",
        },
        {
          title: "网络安全",
          description:
            "网络安全基础、渗透测试、安全防护，成为专业的网络安全专家。",
          category: "软件工程与IT",
        },
        {
          title: "美甲师",
          description: "美甲技术、护理技巧、时尚设计，掌握专业美甲技能。",
          category: "服务业",
        },
        {
          title: "按摩理疗师",
          description: "按摩技术、理疗知识、健康护理，成为专业的理疗师。",
          category: "服务业",
        },
      ],
    },
    info: {
      title: "通用智能",
      pageTitle: "AI 助手",
      tagline:
        "一个指令完成各种任务，精准搜索、智能对话、内容生成——告别信息过载。",
      categories: [
        "全部",
        "搜索助手",
        "内容生成",
        "数据分析",
        "生活助手",
        "生产力工具",
      ],
      inDevelopment: "开发中",
      searchPlaceholder: "你想做什么？告诉我你的需求...",
      servicesTitle: "我能为你做什么？",
      servicesSubtitle: "选择你需要的AI功能，或直接在搜索框描述你的需求",
      bottomTitle: "少一点结构，多一点智能",
      bottomDesc: "无需复杂操作，告诉AI你的需求，我们帮你完成",
      services: {
        aiSearch: {
          title: "AI智能搜索",
          description: "精准搜索信息，快速找到你需要的内容，告别信息过载。",
          category: "搜索助手",
        },
        aiChat: {
          title: "AI对话助手",
          description:
            "一个指令帮你完成各种任务，回答任何问题，就像身边的智能助手。",
          category: "搜索助手",
        },
        docTranslate: {
          title: "文档翻译",
          description:
            "将文档翻译成任何语言，保持原始格式和语调，支持中英互译。",
          category: "内容生成",
        },
        resume: {
          title: "简历撰写",
          description: "帮你撰写专业简历、CV和求职信，提升求职成功率。",
          category: "生产力工具",
        },
        emailWrite: {
          title: "邮件撰写",
          description: "撰写正式、专业的商务邮件，适用于各种场合和场景。",
          category: "生产力工具",
        },
        dataOrg: {
          title: "数据整理",
          description:
            "将混乱的数据整理成清晰、有序的表格格式，便于分析和使用。",
          category: "数据分析",
        },
        bilingual: {
          title: "双语输出",
          description: "获取并排的双语文本版本，支持任意两种语言的对照翻译。",
          category: "内容生成",
        },
        calcTool: {
          title: "自定义计算工具",
          description: "创建专业在线工具，如自定义计算器、单位转换器等。",
          category: "数据分析",
        },
        calendarRemind: {
          title: "日程提醒",
          description: "设置自动会议提醒，连接Google日历，不再错过重要事件。",
          category: "生活助手",
        },
        imageProcess: {
          title: "AI图片处理",
          description: "轻松编辑图片，移除背景、提升质量、应用各种修改效果。",
          category: "内容生成",
        },
        codeGen: {
          title: "代码生成",
          description: "根据需求生成代码片段，支持多种编程语言和框架。",
          category: "生产力工具",
        },
        design: {
          title: "设计助手",
          description: "生成设计稿、创建PPT、制作网站原型等设计相关任务。",
          category: "内容生成",
        },
        localization: {
          title: "内容本地化",
          description: "将内容适配到新市场，进行文化和语言本地化处理。",
          category: "内容生成",
        },
        communityQA: {
          title: "社区问答",
          description:
            "回答华人社区相关的问题，提供生活、工作、学习等各方面建议。",
          category: "生活助手",
        },
        jobAssistant: {
          title: "求职助手",
          description: "提供求职建议、面试准备、薪资谈判等职业发展相关帮助。",
          category: "生产力工具",
        },
        dataExport: {
          title: "数据导出",
          description: "从文档中提取关键信息并组织成结构化表格格式。",
          category: "数据分析",
        },
        copyEdit: {
          title: "文案润色",
          description: "改进和增强文本，提高清晰度、风格和影响力。",
          category: "内容生成",
        },
        customerService: {
          title: "客服助手",
          description: "自动回复客户咨询，处理常见问题，提升服务效率。",
          category: "生产力工具",
        },
        more: {
          title: "更多服务",
          description: "更多AI服务正在开发中，敬请期待...",
          category: "",
        },
      },
    },
    aiEducation: {
      title: "AI 互动课堂",
      inDevelopment: "开发中",
      brandName: "AI教育",
      searchPlaceholder: "搜索课程...",
      create: "创建",
      login: "登录",
      sidebarHome: "首页",
      sidebarBookmark: "收藏",
      sidebarHistory: "历史",
      sidebarCourses: "课程",
      sidebarSubscribe: "订阅",
      sidebarSettings: "设置",
      sidebarStudio: "工作室",
      backToEducation: "返回传统教育",
      heroSubline:
        "摆脱死板的固定视频，保持严谨的专业教学内容大纲，随时跟导师交互",
      pasteVideoPrompt: "粘贴视频链接或描述你的视频",
      coursesTitle: "课程",
      viewDetails: "查看详情",
      lessonsCount: "{n} 课时",
      updatedAt: "更新于 {time}",
      noCoursesFound: "未找到相关课程",
      levelBeginner: "初级",
      levelIntermediate: "中级",
      levelAdvanced: "高级",
      courses: [
        {
          title: "AI驱动的英语学习",
          description:
            "从零基础到流利交流，AI智能评估你的发音和语法，提供个性化练习",
          level: "levelBeginner",
          duration: "8周",
          lessons: "8",
          category: "语言学习",
          instructor: "张老师",
          updated: "1天前",
        },
        {
          title: "AI编程助手课程",
          description: "学习如何使用AI工具提升编程效率，掌握现代软件开发技能",
          level: "levelIntermediate",
          duration: "12周",
          lessons: "12",
          category: "技术技能",
          instructor: "李老师",
          updated: "2天前",
        },
        {
          title: "AI数据分析实战",
          description: "利用AI工具进行数据分析和可视化，成为数据驱动决策的专家",
          level: "levelAdvanced",
          duration: "10周",
          lessons: "10",
          category: "数据科学",
          instructor: "王老师",
          updated: "3天前",
        },
        {
          title: "AI职场应用",
          description:
            "了解AI在工作场景中的应用，学习如何用AI提升工作效率与职业能力",
          level: "levelIntermediate",
          duration: "6周",
          lessons: "6",
          category: "职业技能",
          instructor: "陈老师",
          updated: "1周前",
        },
        {
          title: "AI内容创作",
          description: "掌握AI辅助写作、设计和内容创作，提升创意产出效率",
          level: "levelBeginner",
          duration: "4周",
          lessons: "4",
          category: "创意技能",
          instructor: "刘老师",
          updated: "5天前",
        },
        {
          title: "AI职业规划",
          description: "AI分析你的技能和兴趣，为你推荐最适合的职业发展路径",
          level: "levelBeginner",
          duration: "2周",
          lessons: "2",
          category: "职业发展",
          instructor: "赵老师",
          updated: "1天前",
        },
      ],
    },
    shopping: {
      title: "发现本地商家",
      categories: [
        "全部",
        "美食餐饮",
        "日用百货",
        "生鲜蔬果",
        "服装鞋帽",
        "电子产品",
        "家居用品",
        "美妆护理",
      ],
      delivery: "配送",
      addToCart: "加入购物车",
      searchPlaceholder: "搜索商品...",
      filter: "筛选",
      categoryTitle: "商品分类",
      foundProducts: "共找到 {count} 件商品",
      sort: {
        newest: "最新",
        priceLow: "价格从低到高",
        priceHigh: "价格从高到低",
        rating: "评分最高",
        sales: "销量优先",
      },
      inDevelopment: "开发中，敬请期待",
    },
    hr: {
      people: "人员",
      teamMembersDeptsRoles: "团队成员 · 部门 · 开放职位",
      myProfile: "我的档案",
      addPerson: "添加人员",
      demoBanner:
        "演示数据 — 连接后端 API 可管理真实记录。您可以使用此示例数据浏览界面。",
      overview: "概览",
      attendance: "打卡",
      analytics: "分析",
      directory: "花名册",
      orgChart: "组织架构",
      reviews: "绩效评审",
      benefits: "福利",
      ptoPolicy: "假期政策",
      positions: "职位",
      auditLog: "审计日志",
      totalPeople: "总人数",
      fullTime: "全职",
      partTime: "兼职",
      interns: "实习生",
      onLeaveToday: "今日请假",
      departments: "部门",
      addDepartment: "添加部门",
      teamMembers: "团队成员",
      viewAll: "查看全部",
      upcomingLeave: "即将休假",
      companyHolidays: "公司节假日",
      announcements: "公告",
      myTeam: "我的团队",
      noUpcomingLeave: "未来 14 天内暂无休假",
      noAnnouncements: "暂无公告",
      noPeopleYet: "暂无人员",
      noPeopleFound: "未找到人员",
      tryAdjustFilters: "请尝试调整筛选条件",
      attendanceDesc:
        "请假和缺勤均为打卡的一部分。当日已批准的请假将显示为「请假」。",
      clockIn: "上班打卡",
      clockOut: "下班打卡",
      name: "姓名",
      status: "状态",
      clockInCol: "上班",
      clockOutCol: "下班",
      noAttendanceData: "该日期暂无打卡数据",
      statusActive: "在职",
      statusOnLeave: "今日请假",
      statusOffboarded: "已离职",
      typeFullTime: "全职",
      typePartTime: "兼职",
      typeVolunteer: "志愿者",
      typeIntern: "实习",
      typeContractor: "外包",
      attPresent: "出勤",
      attLeave: "请假",
      attAbsent: "缺勤",
      attLate: "迟到",
      attWfh: "远程",
      attBusinessTrip: "出差",
      leaveVacation: "年假",
      leaveSick: "病假",
      leavePersonal: "事假",
      leaveOther: "其他",
      allStatus: "全部状态",
      allDepartments: "全部部门",
      allTypes: "全部类型",
      searchPlaceholder: "搜索姓名或邮箱...",
      exportCSV: "导出 CSV",
      export: "导出",
      selected: "已选",
      importCSV: "导入 CSV",
      bulkActions: "批量操作",
      changeStatus: "更改状态...",
      offboard: "离职",
      clear: "清除",
      pageOf: "第 {page}/{pages} 页 · 共 {total} 人",
      addDepartmentTitle: "添加部门",
      editDepartment: "编辑部门",
      editPosition: "编辑职位",
      addPersonTitle: "添加人员",
      addPosition: "添加职位",
      editPerson: "编辑人员",
      edit: "编辑",
      displayName: "显示名称",
      email: "邮箱",
      firstName: "名",
      lastName: "姓",
      department: "部门",
      position: "职位",
      manager: "上级",
      employmentType: "雇佣类型",
      startDate: "入职日期",
      endDate: "离职日期",
      phone: "电话",
      notes: "备注",
      description: "描述",
      emergencyContact: "紧急联系人",
      salary: "薪资",
      compBand: "职级",
      equity: "股权",
      ptoAccrued: "已累计假期（小时）",
      cancel: "取消",
      save: "保存",
      post: "发布",
      noNotifications: "暂无通知",
      notifications: "通知",
      addPlan: "添加计划",
      addCycle: "添加周期",
      addReview: "添加评审",
      addCycleTitle: "添加评审周期",
      addReviewTitle: "添加绩效评审",
      editReviewTitle: "编辑评审",
      selfReview: "自评",
      managerFeedback: "上级反馈",
      rating: "评分",
      cycle: "周期",
      reviewCycles: "评审周期",
      employee: "员工",
      draft: "草稿",
      selfSubmitted: "已提交自评",
      managerSubmitted: "已提交上级反馈",
      completed: "已完成",
      meets: "达标",
      exceeds: "超预期",
      below: "待改进",
      noRating: "未评分",
      addBenefitPlan: "添加福利计划",
      addPTOPolicy: "添加假期政策",
      runAccrual: "执行累计",
      headcountByDept: "按部门人数",
      tenureDistribution: "在职时长分布",
      active: "在职",
      inactive: "停用",
      avgTenureMonths: "平均在职（月）",
      attrition12m: "12 个月内离职",
      benefitPlans: "福利计划",
      ptoPolicies: "假期累计政策",
      auditEntries: "条记录",
      noBenefitPlans: "暂无福利计划",
      noPtoPolicies: "暂无假期累计政策",
      noAuditEntries: "暂无审计记录",
      noPositionsYet: "暂无职位",
      noCyclesYet: "暂无周期",
      selectCycle: "选择周期",
      noReviewsInCycle: "本周期暂无评审",
      internalNotes: "内部备注（员工不可见）",
      noPosition: "无职位",
      unassigned: "未分配",
      addLeave: "添加请假",
      leave: "请假",
      leavePending: "待审批",
      addGoal: "添加目标",
      goals: "目标",
      compensation: "薪酬",
      compensationHistory: "薪酬历史",
      dependents: "家属",
      onboardingTasks: "入职任务",
      offboardingTasks: "离职任务",
      documents: "文档",
      oneOnOneNotes: "一对一记录",
      toastOffboarded: "已离职",
      toastCsvExported: "已导出 CSV",
      toastPunchedIn: "已上班打卡",
      toastPunchedOut: "已下班打卡",
      toastPunchInFailed: "上班打卡失败",
      toastPunchOutFailed: "下班打卡失败",
      toastLeaveApproved: "已批准请假",
      toastLeaveDenied: "已拒绝请假",
      toastSaved: "已保存",
      toastImportDone: "导入完成：{ok} 人已添加，{err} 人失败",
      toastAccrualRun: "累计完成：{updated} 人已更新，{skipped} 人跳过",
      toastCsvInvalid: "CSV 需包含表头及至少一行数据",
      toastExported: "已导出 {count} 人",
      toastUpdated: "已将 {count} 人更新为 {status}",
      deptEngineering: "工程",
      deptProduct: "产品",
      deptMarketing: "市场/增长",
      deptOperations: "运营",
      deptCommunity: "社区",
      title: "内部人事管理",
      subtitle: "添加、移除人员并分配职位。仅供内部使用。",
      namePlaceholder: "请输入姓名",
      selectPosition: "选择职位",
      positionPlaceholder: "输入或选择职位",
      positionOptions: [
        "软件工程师",
        "后端工程师",
        "前端工程师",
        "产品经理",
        "社区运营",
        "设计师",
        "志愿者",
        "其他",
      ],
      emailPlaceholder: "选填",
      add: "添加",
      peopleList: "人员列表",
      actions: "操作",
      remove: "移除",
      confirmRemove: "确定要移除此人吗？",
      noPeople: "暂无人员",
      noPeopleHint: "使用上方表单添加人员。",
      internalOnly: "内部使用 · 数据保存在本地浏览器",
    },
    match: {
      title: "华人社交",
      subtitle: "连接华人社区，拓展人脉与职业机会。",
      inDevelopment: "开发中，敬请期待",
    },
    join: {
      title: "加入我们",
      subtitle: "与志同道合的伙伴一起，为华人社区打造更好的AI平台。",
      missionTitle: "我们的使命",
      missionDesc:
        "我们致力于为华人社区提供教育与信息服务。如果你认同我们的愿景与使命，欢迎加入我们。",
      advantages: [
        { title: "使命驱动", desc: "与团队一起服务华人社区，创造真实价值" },
        { title: "成长空间", desc: "在非盈利与科技结合的环境中快速成长" },
        { title: "多元团队", desc: "与来自不同背景的伙伴协作共进" },
      ],
      contactTitle: "加入我们",
      contactDesc: "请将简历发送至以下邮箱，我们会尽快与你联系。",
      sendResume: "发送简历至",
      positionsTitle: "开放职位",
      positions: [
        {
          title: "AI/软件工程师",
          desc: "参与平台与AI产品开发与迭代。",
          type: "全职 / 兼职 / 实习 / 志愿者",
        },
        {
          title: "UI/UX 设计",
          desc: "负责产品界面与用户体验设计。",
          type: "全职 / 兼职 / 实习 / 志愿者",
        },
        {
          title: "市场/增长",
          desc: "市场与品牌推广、增长策略、活动策划。",
          type: "全职 / 兼职 / 实习 / 志愿者",
        },
        {
          title: "项目经理",
          desc: "项目规划、进度与资源协调，推动落地。",
          type: "全职 / 兼职 / 实习 / 志愿者",
        },
        {
          title: "产品经理",
          desc: "产品规划、需求与优先级，连接用户与研发。",
          type: "全职 / 兼职 / 实习 / 志愿者",
        },
        {
          title: "校园大使 / 地区·城市负责人",
          desc: "在校园或本地代表我们，拓展社区与城市级活动与运营。",
          type: "实习 / 兼职 / 全职 / 志愿者",
        },
      ],
      noPosition: "没找到心仪的职位？提出你的想法，创造正向影响。",
      proposeRoleHint:
        "如果没有看到合适的职位，也可以提出你认为能产生正向影响的角色！",
      sendResumeButton: "发送简历",
      joinModalTitle: "加入我们",
      joinModalMessage: "请将简历或咨询发送至人力资源团队：",
      sendEmailButton: "发送邮件至 hr@chinesecommunity.ai",
      closeModal: "关闭",
    },
    careers: {
      heroTitle: "加入我们",
      heroSubtitle: "与志同道合的伙伴一起，为华人社区打造更好的AI平台。",
      missionTitle: "我们的使命",
      missionDesc: "我们致力于为华人社区提供教育与信息服务。如果你认同我们的愿景与使命，欢迎加入我们。",
      whyJoinTitle: "为什么加入 CCAI",
      positionsTitle: "开放职位",
      applyNow: "立即申请",
      proposeRole: "没找到心仪的职位？提出你的想法，创造正向影响。",
      formTitle: "提交申请",
      formName: "姓名",
      formNamePlaceholder: "请输入全名",
      formEmail: "邮箱",
      formEmailPlaceholder: "your@email.com",
      formPhone: "电话（选填）",
      formPhonePlaceholder: "电话号码",
      formPosition: "申请职位",
      formPositionOther: "其他 / 自定义角色",
      formType: "工作类型",
      formTypeOptions: {
        full_time: "全职",
        part_time: "兼职",
        intern: "实习",
        volunteer: "志愿者",
      },
      formResume: "上传简历",
      formResumeHint: "支持 PDF、DOC、DOCX，最大 10MB",
      formResumeSelected: "已选择文件",
      formCoverLetter: "自我介绍 / 求职信（选填）",
      formCoverLetterPlaceholder: "简要介绍你自己，以及你为什么想加入 CCAI...",
      formLinkedIn: "LinkedIn / 作品集链接（选填）",
      formLinkedInPlaceholder: "https://linkedin.com/in/...",
      formSubmit: "提交申请",
      formSubmitting: "提交中...",
      successTitle: "申请已提交！",
      successMessage: "感谢你的申请！我们会尽快审核并与你联系。你可以在控制台中查看申请状态。",
      successGoToDashboard: "前往控制台",
      successApplyAnother: "再次申请",
      errorTitle: "提交失败",
      loginToApply: "登录后申请",
      loginToApplyDesc: "创建帐户或登录以提交你的申请。",
    },
    dashboard: {
      title: "控制台",
      tabs: {
        applications: "我的申请",
        profile: "个人资料",
        admin: "管理",
      },
      noApplications: "暂无申请记录",
      noApplicationsHint: "浏览我们的开放职位并提交你的第一份申请。",
      browsePositions: "浏览职位",
      applicationCard: {
        position: "职位",
        submitted: "提交于",
        status: "状态",
        viewResume: "查看简历",
      },
      statusLabels: {
        submitted: "已提交",
        under_review: "审核中",
        interview: "面试中",
        accepted: "已录用",
        rejected: "未通过",
      },
      profile: {
        title: "个人资料",
        username: "用户名",
        email: "邮箱",
        phone: "电话",
        phonePlaceholder: "电话号码",
        bio: "个人简介",
        bioPlaceholder: "简要介绍自己...",
        linkedin: "LinkedIn",
        linkedinPlaceholder: "https://linkedin.com/in/...",
        save: "保存",
        saving: "保存中...",
        saved: "已保存",
      },
      devBanner: "开发模式 — 自动登录为 dev_user",
      admin: {
        applicationsTitle: "申请审核",
        filterAll: "全部",
        searchPlaceholder: "按姓名、邮箱或职位搜索…",
        positionsTitle: "职位管理",
        addPosition: "添加职位",
        editPosition: "编辑",
        deletePosition: "删除",
        savePosition: "保存",
        cancelEdit: "取消",
        usersTitle: "用户管理",
        changeRole: "更改角色",
        reviewerNotes: "审核备注",
        reviewerNotesPlaceholder: "输入审核备注…",
        downloadResume: "下载简历",
        previewResume: "预览简历",
        noResults: "没有找到匹配的结果",
        colName: "姓名",
        colEmail: "邮箱",
        colPosition: "职位",
        colType: "类型",
        colDate: "日期",
        colStatus: "状态",
        colUsername: "用户名",
        colRole: "角色",
        colJoined: "注册日期",
        colActions: "操作",
        statusUpdate: "更新状态",
        coverLetter: "求职信",
        phone: "电话",
        linkedin: "LinkedIn",
        positionTitle: "职位名称",
        positionTitlePlaceholder: "输入职位名称",
        positionDescription: "职位描述",
        positionDescriptionPlaceholder: "输入职位描述…",
        positionType: "类型",
        confirmDelete: "确认删除此职位？",
        resumePlaceholder: "开发模式下不可下载简历",
        employmentTypes: {
          full_time: "全职",
          part_time: "兼职",
          intern: "实习",
          volunteer: "志愿者",
        },
        roles: {
          employee: "员工",
          manager: "经理",
          admin: "管理员",
        },
      },
    },
    otherServices: {
      title: "其他服务",
      subtitle: "更多服务在规划中，合规优先、分步推进。",
      intro1:
        "我们希望能提供尽可能多的服务，但需要一步一步来；同时严格遵守法律法规，在非营利结构下，部分服务目前仅处于规划阶段。",
      intro2: "以下服务已预留页面，待合规与资源就绪后将逐步开放。",
      plannedTitle: "规划中的服务",
      pendingBadge: "规划中",
      desc: {
        shopping: "发现并连接本地华人商家，购物与配送一站式。",
        match: "社交与活动匹配，连接志同道合的伙伴。",
        ride: "AI 叫车帮助，匹配路线与司机。",
        creators: "社区达人对接，优质 UGC 与品牌合作。",
        media: "短视频、纪录片等文化内容。",
      },
    },
    footer: {
      about: {
        title: "关于我们",
        platform: "平台简介",
        mission: "我们的使命",
        contact: "联系我们",
        teams: "团队",
        join: "加入我们",
      },
      services: {
        title: "核心服务",
        other: "其他服务",
      },
      moreServices: {
        title: "更多服务",
      },
      follow: {
        title: "关注我们",
      },
      copyright: "© {year} Chinese Community AI. All rights reserved.",
      tagline: {
        vision: "AI-powered community platform for overseas Chinese",
        mission: "Nonprofit, giving back to the community",
      },
    },
    wiki: {
      title: "CCAI 维基",
      backToSite: "chinesecommunity.ai",
      allWiki: "全部维基",
      searchPlaceholder: "搜索维基…",
      searchDialog: "搜索维基",
      noResults: "无结果",
      navLabel: "导航",
      home: "首页",
      search: "搜索",
      glossary: "术语表",
      myDrafts: "我的草稿",
      communityPages: "社区页面",
      newPage: "新建页面",
      reviewQueue: "审核队列",
      readOnly: "只读",
      lastUpdated: "最后更新",
      reviewBy: "复审截止",
      ownerTitle: "页面负责人",
      fallbackBanner:
        "此页正文中文译本筹备中，以下为英文原文。欢迎通过 PR 在 content/wiki/zh/ 补充翻译。",
      notFoundTitle: "页面未找到",
      notFoundDesc: "该维基页面不存在。",
      backHome: "返回维基首页",
      searchTitle: "搜索",
      searchIntro: "使用顶部搜索栏或按 ⌘K。已索引 {count} 个页面。",
      searchInputPlaceholder: "搜索…",
      noResultsFor: "未找到与「{q}」相关的结果",
      status: {
        stable: "稳定",
        draft: "草稿",
        deprecated: "已弃用",
      },
    },
    placeholder: {
      defaultDesc: "此页面正在开发中，敬请期待！",
      delivery: {
        name: "发现本地商家",
        description: "发现并连接本地华人商家，支持购物与配送一站式服务。",
      },
      streaming: {
        name: "媒体内容",
        description: "丰富的文化内容，包括短视频、纪录片，弘扬中华文化。",
      },
      contact: {
        name: "联系我们",
        description:
          "我们欢迎你的反馈和建议。让我们一起建设更好的华人社区平台。",
      },
      forum: { name: "社区论坛", description: "此功能已整合到社区论坛中。" },
      offers: { name: "录取汇报", description: "此功能已整合到教育服务中。" },
      jobs: { name: "就业求职", description: "此功能已整合到教育服务中。" },
      visa: { name: "签证移民", description: "此功能已整合到法律帮助中。" },
      salary: { name: "薪资数据", description: "此功能已整合到教育服务中。" },
      notFound: { name: "404 - 页面未找到", description: "" },
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Project & Research",
      impact: "Impact",
      about: "About",
      teams: "Teams",
      joinUs: "Join Us",
      agentBi: "Agent BI",
      sillyDragon: "Silly Dragon",
      ai: "AI Assistant",
      forum: "Information",
      shopping: "Find Local Businesses",
      education: "Education",
      moreServices: "More Services",
      creators: "Community Influencers",
      dating: "Networking",
      legal: "Legal Help",
      ride: "Ride Help",
      community: "Aid Partnership",
      hr: "Human Resources",
      membership: "Membership",
      login: "Login",
      logout: "Log Out",
      dashboard: "Dashboard",
      careers: "Careers",
      searchPlaceholder: "AI Search...",
      moreToCome: "More to come",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    common: {
      inDevelopment: "In Development",
      inDevelopmentDesc: "Coming soon",
      learnMore: "Learn More",
      experience: "Try It",
      moreInfo: "Learn More",
      search: "Search",
      clear: "Clear",
      previous: "Previous",
      next: "Next",
      page: "Page {num}",
      totalPosts: "Total {count} posts",
      langSwitchEn: "Switch to English",
      langSwitchZh: "Switch to Chinese",
    },
    home: {
      heroTitle: "Chinese Community AI",
      heroTagline: "Democratize AI and technology for all communities.",
      heroTaglineSmall:
        "Starting with the Chinese community, where our strength and resources are.",
      heroDescription:
        "We started in 2026. At CCAI, our AI-native teams use artificial intelligence and technology for education, information access, community support, and more.",
      heroDescription2:
        "We also make Chinese communities and services more accessible to everyone.",
      title: "Chinese Community AI - Your Smart Community Gateway",
      subtitle:
        "Education, information access, and community support through AI—one place for learning, finding resources, and connecting with the community. We also make the Chinese community accessible to others. Mission-driven and nonprofit.",
      badge1: "Work in Progress",
      badgeMvp: "MVP",
      badgeEarlyAccess: "Early Access",
      badgePlanning: "Planning",
      badge2: "Nonprofit, 501c3 in progress",
      servicesTitle: "Services",
      projectsTitle: "Project & Research (WIP)",
      impactTitle: "Impact",
      aboutTitle: "About",
      teamsTitle: "Teams",
      teamsSubtitle: "",
      peopleTitle: "Teams",
      teamsCredibility:
        "Our teams include professionals from Meta, Google, Amazon, Uber and more. Our early talents come from Ivy League schools and beyond.",
      teamsViewAll: "View all",
      joinUsTitle: "Join Us",
      joinUsSubtitle: "",
      teams: {
        board: "Board Team",
        boardMember0: { name: "Jiahong (Jahong) Liu", role: "Founder" },
        boardMember1: {
          name: "Joseph Venanzio",
          role: "Board & Chief Technology",
        },
        boardMember2: {
          name: "Hassan Mahamat",
          role: "Board & Chief Security",
        },
        boardMember3: { name: "Ben Zheng", role: "Board & Chief Operation & Marketing" },
        boardMember4: { name: "Jiabei (Nicole) Liu", role: "Board & AI Software Engineer" },
        boardMember5: { name: "Mizo", role: "Non-voting Board & Chief Vibe Officer" },
        aiSoftwareEngineerTeam: "AI Software Engineer Team",
        aidTeam: "Aid Team",
        dataTeam: "Data Team",
        marketingTeam: "Marketing/Growth Team",
        securityTeam: "Responsible AI & Security Team",
        legalTeam: "Legal Team",
        uiuxTeam: "UI/UX Team",
        hrTeam: "HR Team",
        productTeam: "Product Team",
        mentorsTeam: "Advisor / Mentor Team",
      },
      teamMembers: {
        aiSoftwareEngineerTeam: [
          { name: "Zhijie Yan", role: "AI Software Engineer" },
          { name: "Kehan Xiao", role: "AI Software Engineer" },
          { name: "HanYang (Eric) Zheng", role: "AI Software Engineer" },
          { name: "Fiona Li", role: "AI Software Engineer" },
          { name: "Peiwen Zhong", role: "AI Software Engineer" },
          { name: "Eltayeb E", role: "Project Manager" },
          { name: "Niki Mai", role: "Project Manager" },
        ],
        legalTeam: [{ name: "Yangqing Zhang", role: "Legal Counsel" }],
        marketingTeam: [
          { name: "Ben Zheng", role: "Board & Chief Operation & Marketing" },
          { name: "Yitong Liang", role: "Marketing Specialist" },
        ],
        dataTeam: [
          { name: "Libin (Peter) Chen", role: "Data Scientist" },
          { name: "Yiting Wang", role: "Data Scientist" },
        ],
        aidTeam: [],
        securityTeam: [
          { name: "Robert Maina", role: "CISO" },
          { name: "Benson Jengela", role: "InfoSec Engineer" },
          { name: "Joel Nyirongo", role: "InfoSec Engineer" },
          { name: "Mahdi Alajmi", role: "InfoSec Engineer" },
        ],
        mentorsTeam: [
          { name: "Yue (Amanda) Yao", role: "Content Advisor" },
          { name: "Anqi Nie", role: "Technical Advisor" },
          { name: "Sean Galvan", role: "Health Advisor" },
          { name: "Hadi Jaber", role: "External Relations & Partnership Advisor" },
          { name: "Xuxin (Peter) Han", role: "Technical Advisor" },
          { name: "Xingdong (Sheldon) Li", role: "Technical Advisor" },
          { name: "Zichong Meng", role: "Research Advisor" },
        ],
        uiuxTeam: [
          { name: "Jiajia (Cindy) Chen", role: "UI/UX Designer" },
        ],
        hrTeam: [{ name: "Xinyan Lin", role: "HR" }],
        productTeam: [
          { name: "Jiajia (Cindy) Chen", role: "Product Manager" },
          { name: "Eliana You", role: "Product Manager" },
        ],
      },
      servicesSubtitle:
        "AI-driven education and community services for information access, tech literacy, and community mutual aid",
      moreServicesToCome: "More services to come",
      moreServicesToComeDesc:
        "We are continuously developing new features. Stay tuned.",
      moreProjectsToCome: "More projects to come",
      moreProjectsToComeDesc:
        "We are continuously developing new features. Stay tuned.",
      stats: {
        traffic: "Cross-platform Traffic",
        fans: "Cross-platform Followers",
        merchants: "Intended Community Partners",
        financialSupport: "Financial Support for Community",
        earlyTalent: "Early talent mentored",
        volunteers: "Workers & Volunteers Engaged",
        communityMembers: "Community Members",
        andCounting: "and counting",
      },
      mission: {
        title: "Our Mission",
        description: "",
        vision: "Nonprofit, giving back to the community.",
        goal: "Vision: AI-powered community platform for overseas Chinese and all",
        brandName: "Chinese Community AI",
      },
      problems: {
        title: "Problems with Traditional Platforms",
        items: [
          "Information overload, hard to find useful information",
          "Commerce-oriented, ignoring Chinese community needs",
          "Immigrants and underserved communities face the digital divide",
        ],
      },
      solutions: {
        title: "Our Solutions",
        items: [
          "AI-driven search and information access for learning and daily tasks",
          "Community needs first, serving underserved Chinese communities and more",
          "Connect community resources and information; promote digital inclusion and tech literacy; also opens community access to all",
        ],
      },
      features: {
        agentBi: {
          title: "Agent BI",
          description:
            "Democratize Agentforce/Salesforce-like products for nonprofits and small Chinese businesses—intelligence and data for good. Humans with agents drive people success together.",
        },
        ai: {
          title: "AI Assistant",
          description:
            "AI-driven precise search and universal AI assistant. One command to complete your tasks, say goodbye to information overload, enjoy intelligent experience.",
          comingSoon: "COMING SOON",
          tagline:
            "One command for any task—search, chat, and create and more.",
          searchPlaceholder: "What would you like to do? Tell me your needs...",
        },
        forum: {
          title: "Information",
          description:
            "Connect elders, new immigrants, and students in the Chinese community. Share experiences, build friendships, grow together.",
        },
        shopping: {
          title: "Find Local Businesses",
          description:
            "Discover and connect with local Chinese businesses; shop and get delivery in one place.",
        },
        legal: {
          title: "Legal Help",
          description:
            "Professional legal consultation and help for new immigrants and community members.",
        },
        education: {
          title: "Education",
          description:
            "Make education accessible with an interactive AI teacher. Quality courses in software engineering, data science, and career development.",
        },
        community: {
          title: "Aid Partnership",
          description:
            "Partnering with community to make all aid services more accessible.",
        },
        health: {
          title: "Health",
          description:
            "Democratize health assistance for low medical resource communities with AI technology.",
        },
        sillyDragon: {
          title: "General AI - Silly Dragon",
          description:
            "Democratize AI assistant that can actually do tasks for you.",
        },
        ride: {
          title: "Ride Help",
          description:
            "AI smart ride help, automatically matching optimal routes and drivers, making your travel more convenient and safe.",
        },
      },
    },
    legal: {
      title: "Legal Help",
      subtitle: "Professional legal consultation and help",
      description:
        "Assist new immigrants and community members with legal issues; provide legal consultation and help.",
      inDevelopment: "Coming soon",
      aiAssistantTitle: "AI Legal Assistant",
      aiAssistantSubtitle:
        "24/7 online—get quick answers to your legal questions",
      onlineConsult: "Online consultation",
      startChat: "Start a conversation now",
      service247: "24/7 service",
      anytime: "Here for you anytime",
      quickResponse: "Quick response",
      secondsReply: "Reply in seconds",
      tryAiAssistant: "Try AI Legal Assistant",
      howItWorks: "How it works",
      step1Title: "Submit inquiry",
      step1Desc:
        "Fill out the form or contact us and describe your legal needs",
      step2Title: "Professional assessment",
      step2Desc:
        "Our legal team will review your situation and provide professional advice",
      step3Title: "Solution",
      step3Desc:
        "We develop a solution and help you with your legal matter and protect your rights",
      lawFirmsTitle:
        "Partner law firms (sample reference only, not real listings)",
      lawFirmsIntro:
        "For professional legal services, we work with well-known Chinese-American law firms to serve the community",
      yearsInPractice: "{years} years in practice",
      rating: "Rating",
      specialtiesLabel: "Practice areas:",
      contactFirm: "Contact firm",
      whyChooseUs: "Why choose us",
      proTeam: "Expert team",
      proTeamDesc: "Experienced Chinese-American legal team",
      privacy: "Privacy protection",
      privacyDesc:
        "Strict protection of client privacy and information security",
      fastResponse: "Fast response",
      fastResponseDesc: "We respond to inquiries within 24 hours",
      transparentPricing: "Transparent pricing",
      transparentPricingDesc: "Clear service prices, no hidden fees",
      contactFormTitle: "Online consultation",
      nameLabel: "Name *",
      namePlaceholder: "Enter your name",
      emailLabel: "Email *",
      emailPlaceholder: "Enter your email",
      messageLabel: "Inquiry *",
      messagePlaceholder: "Describe your legal question or needs in detail...",
      submitConsult: "Submit inquiry",
      faqTitle: "Frequently asked questions",
      faq1Q: "How are consultation fees calculated?",
      faq1A:
        "We offer transparent pricing. Initial consultations are usually free; specific fees depend on case complexity. All fees are clearly stated before services begin, with no hidden costs.",
      faq2Q: "How long until I get a response?",
      faq2A:
        "We aim to respond within 24 hours. Urgent cases can be prioritized. Response time depends on case complexity and preparation needed.",
      faq3Q: "Can I consult remotely?",
      faq3A:
        "Yes. We support phone, video, and online consultation. For in-person needs, we can arrange on-site visits in the New York area.",
      faq4Q: "What are your lawyers’ qualifications?",
      faq4A:
        "Our attorneys are licensed in the United States with extensive experience serving the Chinese-American community in immigration, real estate, business, and other areas.",
      lawFirms: [
        {
          name: "New York Huamei Law Firm",
          specialties: ["Immigration & Visa", "Business Law", "Real Estate"],
          location: "Manhattan, NY",
          phone: "(212) 555-0100",
          email: "info@huameilaw.com",
          rating: "4.9",
          description:
            "Serving the Chinese-American community for over 20 years; immigration, business, and real estate",
          years: "20+",
        },
        {
          name: "Flushing United Law Firm",
          specialties: ["Immigration & Visa", "Family Law", "Employment Law"],
          location: "Flushing, NY",
          phone: "(718) 555-0200",
          email: "contact@flushinglaw.com",
          rating: "4.8",
          description:
            "Focused on new immigrants; full-range legal consultation and services",
          years: "15+",
        },
        {
          name: "Los Angeles Pacific Law Firm",
          specialties: ["Business Law", "Intellectual Property", "Contracts"],
          location: "Los Angeles, CA",
          phone: "(323) 555-0300",
          email: "info@pacificlaw.com",
          rating: "4.9",
          description:
            "Business legal services and consulting for Chinese-American businesses",
          years: "18+",
        },
        {
          name: "Bay Area Law Firm",
          specialties: ["Immigration & Visa", "Real Estate", "Family Law"],
          location: "San Francisco, CA",
          phone: "(415) 555-0400",
          email: "info@baylaw.com",
          rating: "4.7",
          description:
            "Serving the Bay Area Chinese-American community with an experienced team",
          years: "12+",
        },
        {
          name: "Chicago Midwest Law Firm",
          specialties: ["Business Law", "Immigration & Visa", "Employment Law"],
          location: "Chicago, IL",
          phone: "(312) 555-0500",
          email: "contact@midwestlaw.com",
          rating: "4.8",
          description:
            "Professional legal services for the Midwest Chinese-American community",
          years: "10+",
        },
        {
          name: "Boston New England Law Firm",
          specialties: ["Family Law", "Immigration & Visa", "Real Estate"],
          location: "Boston, MA",
          phone: "(617) 555-0600",
          email: "info@newenglandlaw.com",
          rating: "4.9",
          description:
            "Serving New England Chinese-American community with a professional team",
          years: "14+",
        },
      ],
    },
    community: {
      title: "Aid Partnership",
      inDevelopment: "In development & planning",
      pageSummary:
        "This program is still in development and planning; specific services and timing will be announced as they are confirmed.",
      examplesNote:
        "Services and listings are still in planning; the above are examples only.",
      subtitle: "Free services for a warmer community",
      description:
        "Partnering with community to make all aid services more accessible.",
      missionTitle: "Our mission",
      missionDesc:
        "A warm, united, mutually supportive Chinese community. All services 100% free.",
      freeService: "Free services",
      communityPartners: "Community partners",
      localPartners: "Local partnerships",
      missionDriven: "Mission-driven",
      serveCommunity: "Serving the Chinese community",
      freeServicesTitle: "Free services examples",
      servicesSection: "Services",
      foundServices: "Found {count} free services",
      free: "Free",
      viewAll: "View all",
      upcomingEvents: "Upcoming events",
      learnMore: "Learn more",
      howToParticipate: "How to participate",
      becomeVolunteer: "Become a volunteer",
      volunteerDesc:
        "Use your time and skills to help community members",
      volunteerCta: "Apply to volunteer",
      donate: "Donate",
      donateDesc:
        "100% of donations go to community services",
      donateCta: "Donate now",
      seekHelp: "Get help",
      seekHelpDesc:
        "Need help? Contact us and we’ll do our best to assist",
      seekHelpCta: "Get help",
      contactUs: "Contact us",
      emailContact: "Email",
      phoneContact: "Phone",
      valuesTitle: "Our values",
      unity: "Unity",
      unityDesc:
        "Chinese community standing together and supporting each other",
      mutualAid: "Mutual aid",
      mutualAidDesc: "Helping others helps everyone",
      trust: "Trust",
      trustDesc: "Building a trustworthy community",
      growth: "Growth",
      growthDesc: "Growing and improving together",
      categories: [
        "All",
        "Life services",
        "Mental health",
        "Education",
        "Health",
        "Other",
      ],
      services: [
        {
          title: "Free lunch",
          description:
            "Free nutritious lunch for community members in need, Monday–Friday",
          location: "Pending",
          time: "Pending",
          category: "Life services",
        },
        {
          title: "Free counseling",
          description:
            "Professional counselors offer free mental health consultation",
          location: "Pending",
          time: "Pending",
          category: "Mental health",
        },
        {
          title: "Free legal aid",
          description:
            "Free legal consultation and assistance for low-income community members",
          location: "Pending",
          time: "Pending",
          category: "Other",
        },
        {
          title: "Free English classes",
          description:
            "Free English classes for new immigrants to adapt to life in the US",
          location: "Pending",
          time: "Pending",
          category: "Education",
        },
        {
          title: "Free health screenings",
          description: "Free health screenings and medical consultation",
          location: "Pending",
          time: "Pending",
          category: "Health",
        },
        {
          title: "Free job coaching",
          description:
            "Resume review, interview tips, career planning, and other employment support",
          location: "Pending",
          time: "Pending",
          category: "Education",
        },
        {
          title: "Free essentials",
          description: "Free daily essentials and food for families in need",
          location: "Pending",
          time: "Pending",
          category: "Life services",
        },
        {
          title: "Free translation",
          description:
            "Chinese–English translation to help with language barriers",
          location: "Pending",
          time: "Pending",
          category: "Other",
        },
        {
          title: "Elder care",
          description: "Companionship and emotional support for seniors",
          location: "Pending",
          time: "Pending",
          category: "Mental health",
        },
        {
          title: "Free tax help",
          description:
            "Free tax filing and tax consultation for low-income families",
          location: "Pending",
          time: "Pending",
          category: "Other",
        },
        {
          title: "Free tutoring",
          description:
            "Free after-school tutoring and academic support for children",
          location: "Pending",
          time: "Pending",
          category: "Education",
        },
        {
          title: "Free health talks",
          description:
            "Free health education talks to promote community wellness",
          location: "Pending",
          time: "Pending",
          category: "Health",
        },
      ],
      events: [
        {
          title: "Free community lunch",
          date: "2026-01-20",
          location: "Pending",
          description:
            "Free nutritious lunch for community members. All welcome.",
          type: "Life services",
        },
        {
          title: "Mental health talk",
          date: "2026-01-18",
          location: "Pending",
          description:
            "Professional counselor on mental health. Free to attend.",
          type: "Mental health",
        },
        {
          title: "Free English corner",
          date: "2026-01-15",
          location: "Pending",
          description: "Practice English and meet new people. Completely free.",
          type: "Education",
        },
        {
          title: "Free health screening",
          date: "2026-01-25",
          location: "Pending",
          description: "Free health check and consultation for the community.",
          type: "Health",
        },
      ],
    },
    ride: {
      title: "Ride Help",
      subtitle: "AI smart ride help",
      description:
        "Automatically match optimal routes and drivers, making your travel more convenient and safe.",
      inDevelopment: "Coming soon",
      pickupLabel: "Pickup",
      destinationLabel: "Destination",
      pickupPlaceholder: "Enter pickup address or use current location",
      destinationPlaceholder: "Enter destination address",
      departureTimeLabel: "Departure time",
      passengersLabel: "Passengers",
      departureNow: "Leave now",
      departureLater: "Leave later",
      departureTomorrow: "Schedule for tomorrow",
      passengersCount: "{n}",
      passengers5Plus: "5+",
      matchButton: "AI Match Ride",
      chooseVehicleTitle: "Choose vehicle",
      futureTechTitle: "Future AI Technology",
      futureTechDesc: "Smart travel, every trip made better",
      routeOptimization: "AI Route Optimization",
      routeOptimizationDesc:
        "Real-time traffic analysis, optimal routes, save time",
      smartDispatch: "Smart Dispatch",
      smartDispatchDesc:
        "AI predicts demand, dispatches vehicles in advance, less waiting",
      safeSmart: "Safety & Intelligence",
      safeSmartDesc: "AI monitoring for a safe, worry-free trip",
      whyChooseTitle: "Why choose us",
      autoDrive: "Autonomous",
      autoDriveDesc:
        "Future AI self-driving vehicles, no driver, safe and comfortable",
      comingSoon: "Coming soon",
      aiRide: "AI Smart Ride",
      aiRideDesc:
        "AI matches optimal routes and drivers, smart dispatch, fastest arrival",
      economy: "Economy",
      economyDesc: "Budget-friendly option",
      comfort: "Comfort",
      comfortDesc: "Spacious and comfortable interior",
      luxury: "Luxury",
      luxuryDesc: "Premium vehicles, premium experience",
      featureAuto: "Autonomous",
      featureNav: "AI navigation",
      featureSafe: "Safe & reliable",
      featureFuture: "Future tech",
      featureRoute: "AI route optimization",
      featureMatch: "Smart match",
      featureTrack: "Real-time tracking",
      featureBudget: "Budget-friendly",
      featureFast: "Fast arrival",
      featureSeat: "Comfortable seats",
      featureSpace: "More space",
      featureCar: "Premium vehicle",
      featureDriver: "Professional driver",
      devNote:
        "We are developing more advanced AI to make ride help smarter and more convenient.",
      futureNote:
        "We are partnering with leading autonomous driving companies and expect to launch fully autonomous ride help in the coming years for safer, more convenient, and greener travel.",
    },
    creators: {
      title: "Community Influencers",
      heroTitle: "Better Chinese UGC starts with better creators",
      heroDesc:
        "Skip the cold start and connect directly with high-quality Chinese creators. We use AI to understand brand needs and content style, match creators skilled in short-form video and conversion content, and improve campaign efficiency and quality.",
      publishRequest: "Submit request",
      becomeCreator: "Become a creator",
      flowTitle: "How it works",
      steps: [
        {
          title: "Submit request",
          description:
            "Tell us the number of creators, target audience, and content direction.",
        },
        {
          title: "Review matches",
          description:
            "Review creator profiles, performance data, and past work to shortlist quickly.",
        },
        {
          title: "Start collaboration",
          description:
            "Align with creators and deliver high-quality UGC efficiently.",
        },
      ],
      featuredTitle: "Featured creators",
      featuredSubtitle: "Vetted · Data visible",
      founderBadge: "Creator-driven platform",
      founderTitle: "Built by creators together",
      founderDesc:
        "Through our creator network and AI matching, we provide brands with high-quality UGC creation, reduce trial-and-error cost, and make matching and collaboration more efficient.",
      creatorScore: "Creator score",
      creatorScoreDesc: "Multi-platform short video and commerce",
      pricingTitle: "Pricing",
      pricingCustom: "Custom by need",
      pricingFlexible: "Flexible plans",
      pricingItem1: "Match creators by budget and timeline",
      pricingItem2: "Full creator profiles, data, and quotes",
      pricingItem3: "Support from brief to delivery",
      getPlan: "Get a plan",
    },
    membership: {
      title: "Become a Community Member",
      subtitle: "Support Chinese Community Platform, Enjoy All Services Free",
      description:
        "Membership fees support platform operations and our education and community services. Nonprofit, giving back to the community.",
      cardTitle: "Community Member",
      price: "/month",
      priceDesc: "Support Chinese Community Platform Development",
      benefitsTitle: "Member Benefits",
      benefits: [
        "Free access to all platform services",
        "Priority access to new features",
        "Dedicated customer support",
        "Participate in community decisions",
        "Support Chinese community development",
      ],
      serviceTitle: "Services Available to Members",
      joinButton: "Join Now",
      whyTitle: "Why Become a Member?",
      whyItems: [
        {
          title: "Support Community",
          description:
            "Your support helps the platform continue to serve the Chinese community",
        },
        {
          title: "Free Services",
          description: "Members can use all platform services for free",
        },
        {
          title: "Priority Access",
          description: "Priority access to new features and services",
        },
        {
          title: "Community Participation",
          description:
            "Participate in community decisions, build a better Chinese community platform together",
        },
      ],
      modelTitle: "Membership Model",
      modelDesc:
        "Membership fees support platform operations and service development",
      modelItems: [
        {
          title: "Community Support",
          description:
            "Membership fees are used for platform operations and continuous optimization of community services",
        },
        {
          title: "Free Services",
          description:
            "Members can use education, forum, AI assistant, legal information, and community support services for free.",
        },
        {
          title: "Training & Recruitment",
          description:
            "Provide career training and recruitment services for Chinese community, helping employment and career development",
        },
        {
          title: "Continuous Development",
          description:
            "Membership fees are used for platform operations and service capability enhancement",
        },
      ],
      missionTitle: "Our Mission",
      missionDesc:
        "We are committed to providing education and information services for the Chinese community, connecting community members with educational resources.",
      missionPlatform: "Platform Model",
      missionPlatformDesc:
        "We provide education and community services focused on tech literacy, information access, and community mutual aid.",
      missionRevenue: "Use of Funds",
      missionRevenueDesc:
        "Membership fees support platform operations and education and community services. Support career training and community programs, helping Chinese employment and integration.",
      faqTitle: "Frequently Asked Questions",
      faq: [
        {
          question: "What is the nature of membership fees?",
          answer:
            "Membership fees are platform service support fees used to support platform operations and development. Members can use all platform services for free.",
        },
        {
          question: "How are membership fees used?",
          answer:
            "Membership fees are used for platform operating costs (servers, maintenance, team, etc.) and for continuous optimization of products and services.",
        },
        {
          question: "What services can members enjoy?",
          answer:
            "Members can use AI Assistant, Information, Education, Legal Information, and Community support services for free.",
        },
        {
          question: "Can I cancel membership anytime?",
          answer:
            "Yes, you can cancel membership at any time. After cancellation, you will no longer be able to use services that require membership.",
        },
      ],
      ctaTitle: "Ready to Join?",
      ctaDesc:
        "Become a community member, support the Chinese community platform, and enjoy all services for free",
      ctaButton: "Become a Member Now",
    },
    match: {
      title: "Community Networking",
      subtitle:
        "Connect with the Chinese community and expand your professional network.",
      inDevelopment: "In Development",
    },
    join: {
      title: "Join Us",
      subtitle:
        "Join like-minded people to build a better AI platform for the Chinese community.",
      missionTitle: "Our Mission",
      missionDesc:
        "We are committed to providing education and information services for the Chinese community. If you share our vision and mission, welcome to join us.",
      advantages: [
        {
          title: "Mission-Driven",
          desc: "Work with the team to serve the Chinese community and create real value",
        },
        {
          title: "Room to Grow",
          desc: "Grow quickly in a nonprofit-meets-tech environment",
        },
        {
          title: "Diverse Team",
          desc: "Collaborate with people from different backgrounds",
        },
      ],
      contactTitle: "Join Us",
      contactDesc:
        "Please send your resume to the email below and we will get back to you soon.",
      sendResume: "Send resume to",
      positionsTitle: "Open Positions",
      positions: [
        {
          title: "AI/Software Engineer",
          desc: "Participate in platform and AI product development and iteration.",
          type: "Full-time / Part-time / Intern / Volunteer",
        },
        {
          title: "UI/UX",
          desc: "Product interface and user experience design.",
          type: "Full-time / Part-time / Intern / Volunteer",
        },
        {
          title: "Marketing/Growth",
          desc: "Marketing, growth strategy, brand outreach, and campaign planning.",
          type: "Full-time / Part-time / Intern / Volunteer",
        },
        {
          title: "Project Manager",
          desc: "Project planning, timeline and resource coordination, drive delivery.",
          type: "Full-time / Part-time / Intern / Volunteer",
        },
        {
          title: "Product Manager",
          desc: "Product roadmap, requirements and prioritization, connect users and engineering.",
          type: "Full-time / Part-time / Intern / Volunteer",
        },
        {
          title: "Campus Ambassador / Area or City Lead",
          desc: "Represent us on campus or in your local area; grow community and city-level initiatives.",
          type: "Intern / Part-time / Full-time / Volunteer",
        },
      ],
      noPosition:
        "Don't see a role that you're looking for? Propose your own to make a positive impact.",
      proposeRoleHint:
        "If you don't see a fit, propose a role you believe could make a positive impact!",
      sendResumeButton: "Send Resume",
      joinModalTitle: "Join Us",
      joinModalMessage: "Send your resume or inquiry to our HR team:",
      sendEmailButton: "Send email to hr@chinesecommunity.ai",
      closeModal: "Close",
    },
    careers: {
      heroTitle: "Join Us",
      heroSubtitle: "Join like-minded people to build a better AI platform for the Chinese community.",
      missionTitle: "Our Mission",
      missionDesc: "We are committed to providing education and information services for the Chinese community. If you share our vision and mission, welcome to join us.",
      whyJoinTitle: "Why Join CCAI",
      positionsTitle: "Open Positions",
      applyNow: "Apply Now",
      proposeRole: "Don't see a role that fits? Propose your own to make a positive impact.",
      formTitle: "Submit Your Application",
      formName: "Full Name",
      formNamePlaceholder: "Enter your full name",
      formEmail: "Email",
      formEmailPlaceholder: "your@email.com",
      formPhone: "Phone (optional)",
      formPhonePlaceholder: "Phone number",
      formPosition: "Position",
      formPositionOther: "Other / Propose a Role",
      formType: "Employment Type",
      formTypeOptions: {
        full_time: "Full-time",
        part_time: "Part-time",
        intern: "Intern",
        volunteer: "Volunteer",
      },
      formResume: "Upload Resume",
      formResumeHint: "PDF, DOC, or DOCX — max 10MB",
      formResumeSelected: "File selected",
      formCoverLetter: "Cover Letter / Message (optional)",
      formCoverLetterPlaceholder: "Tell us about yourself and why you'd like to join CCAI...",
      formLinkedIn: "LinkedIn / Portfolio URL (optional)",
      formLinkedInPlaceholder: "https://linkedin.com/in/...",
      formSubmit: "Submit Application",
      formSubmitting: "Submitting...",
      successTitle: "Application Submitted!",
      successMessage: "Thank you for applying! We will review your application and get back to you soon. You can track your application status in the dashboard.",
      successGoToDashboard: "Go to Dashboard",
      successApplyAnother: "Apply Again",
      errorTitle: "Submission Failed",
      loginToApply: "Log in to Apply",
      loginToApplyDesc: "Create an account or sign in to submit your application.",
    },
    dashboard: {
      title: "Dashboard",
      tabs: {
        applications: "My Applications",
        profile: "Profile",
        admin: "Admin",
      },
      noApplications: "No applications yet",
      noApplicationsHint: "Browse our open positions and submit your first application.",
      browsePositions: "Browse Positions",
      applicationCard: {
        position: "Position",
        submitted: "Submitted",
        status: "Status",
        viewResume: "View Resume",
      },
      statusLabels: {
        submitted: "Submitted",
        under_review: "Under Review",
        interview: "Interview",
        accepted: "Accepted",
        rejected: "Rejected",
      },
      profile: {
        title: "Profile",
        username: "Username",
        email: "Email",
        phone: "Phone",
        phonePlaceholder: "Phone number",
        bio: "Bio",
        bioPlaceholder: "Tell us about yourself...",
        linkedin: "LinkedIn",
        linkedinPlaceholder: "https://linkedin.com/in/...",
        save: "Save",
        saving: "Saving...",
        saved: "Saved",
      },
      devBanner: "Dev Mode — auto-logged in as dev_user",
      admin: {
        applicationsTitle: "Applications Review",
        filterAll: "All",
        searchPlaceholder: "Search by name, email, or position…",
        positionsTitle: "Manage Positions",
        addPosition: "Add Position",
        editPosition: "Edit",
        deletePosition: "Delete",
        savePosition: "Save",
        cancelEdit: "Cancel",
        usersTitle: "Manage Users",
        changeRole: "Change Role",
        reviewerNotes: "Reviewer Notes",
        reviewerNotesPlaceholder: "Enter reviewer notes…",
        downloadResume: "Download Resume",
        previewResume: "Preview Resume",
        noResults: "No matching results found",
        colName: "Name",
        colEmail: "Email",
        colPosition: "Position",
        colType: "Type",
        colDate: "Date",
        colStatus: "Status",
        colUsername: "Username",
        colRole: "Role",
        colJoined: "Joined",
        colActions: "Actions",
        statusUpdate: "Update Status",
        coverLetter: "Cover Letter",
        phone: "Phone",
        linkedin: "LinkedIn",
        positionTitle: "Position Title",
        positionTitlePlaceholder: "Enter position title",
        positionDescription: "Description",
        positionDescriptionPlaceholder: "Enter position description…",
        positionType: "Type",
        confirmDelete: "Are you sure you want to delete this position?",
        resumePlaceholder: "Resume download not available in dev mode",
        employmentTypes: {
          full_time: "Full-time",
          part_time: "Part-time",
          intern: "Intern",
          volunteer: "Volunteer",
        },
        roles: {
          employee: "Employee",
          manager: "Manager",
          admin: "Admin",
        },
      },
    },
    otherServices: {
      title: "Other Services",
      subtitle: "More services are in the pipeline—compliant, step-by-step.",
      intro1:
        "We want to provide as many services as possible, but we need to start step by step. We are also committed to compliance with laws and regulations, so some services are pending in our plan based on our nonprofit structure for now.",
      intro2:
        "The services below have dedicated pages and will be rolled out as we meet compliance and resource requirements.",
      plannedTitle: "Planned services",
      pendingBadge: "Planned",
      desc: {
        shopping:
          "Discover and connect with local Chinese businesses; shop and delivery in one place.",
        match:
          "Networking and events matching—connect with like-minded people.",
        ride: "AI ride help—match routes and drivers.",
        creators: "Community creators and UGC; connect brands with creators.",
        media: "Short-form video, documentaries, and cultural content.",
      },
    },
    login: {
      title: "Login",
      registerTitle: "Register",
      welcome: "Welcome Back",
      joinTitle: "Join Chinese Community AI Platform",
      email: "Email",
      usernameOrEmail: "Username or Email",
      username: "Username",
      password: "Password",
      confirmPassword: "Confirm Password",
      passwordPlaceholder: "Password",
      confirmPasswordPlaceholder: "Re-enter password",
      submit: "Login",
      register: "Register",
      processing: "Processing...",
      noAccount: "Don't have an account? Register now",
      hasAccount: "Already have an account? Login now",
      passwordMismatch: "Passwords do not match",
      operationFailed: "Operation failed, please try again later",
    },
    forum: {
      title: "Information",
      categories: "Forum Categories",
      recentPosts: "Recent Posts",
      allPosts: "All Posts",
      threads: "Threads",
      posts: "Posts",
      pinned: "Pinned",
      uncategorized: "Uncategorized",
      anonymous: "Anonymous",
      reply: "Reply",
      views: "Views",
      minutesAgo: "minutes ago",
      hoursAgo: "hours ago",
      daysAgo: "days ago",
      createPost: "Create New Post",
      searchPlaceholder: "Search posts...",
      noPosts: "No posts yet, be the first to post!",
      loading: "Loading...",
      searchResults: "Search Results",
      categoryPosts: "Category Posts",
      showAll: "Show All",
      noSearchResults: "No related posts found",
      noRecentPosts: "No recent posts",
      announcementsTitle: "Announcements",
      subtitle:
        "Connect Chinese community, share life experiences, build friendships, grow together",
      announcements: [
        "Chinese Community AI Platform 2026 New Forum is Live, Welcome!",
        "Community Event: Chinatown Cultural Festival this weekend, everyone welcome",
        "Forum Rules Updated: Please be respectful, build a harmonious community",
      ],
      categoriesList: [
        {
          name: "Housing",
          description: "Rental, buying, selling, home repair information",
        },
        {
          name: "Jobs",
          description: "Job opportunities, recruitment, career sharing",
        },
        {
          name: "Food",
          description:
            "Restaurant recommendations, food sharing, recipe exchange",
        },
        { name: "Secondhand", description: "Used items, buying and selling" },
        {
          name: "Services",
          description: "Convenience services, help requests, community support",
        },
        {
          name: "Events",
          description: "Community events, gatherings, cultural exchange",
        },
      ],
    },
    postDetail: {
      backToForum: "Back to Forum",
      loading: "Loading...",
      notFound: "Post not found",
      edit: "Edit",
      delete: "Delete",
      deleteConfirm: "Are you sure you want to delete this post?",
      deleteFailed: "Delete failed, please try again later",
      views: "Views",
      replies: "Replies",
      replyTitle: "Reply",
      replyPlaceholder: "Write your reply...",
      submitReply: "Submit Reply",
      submitting: "Submitting...",
      replyFailed: "Failed to submit reply, please try again later",
      noReplies: "No replies yet, be the first to reply!",
      anonymous: "Anonymous",
      loginToReply: "Please {login} to reply",
    },
    createPost: {
      backToForum: "Back to Forum",
      title: "Create New Post",
      selectCategory: "Select Category",
      postTitle: "Title",
      titlePlaceholder: "Enter post title...",
      content: "Content",
      contentPlaceholder: "Write what you want to share...",
      cancel: "Cancel",
      submit: "Publish Post",
      submitting: "Publishing...",
      submitFailed: "Publish failed, please try again later",
      loading: "Loading...",
    },
    about: {
      title: "Our Mission",
      body: "We started in 2026. At CCAI, our AI-native teams use artificial intelligence and technology for education, information access, community support, and more. We also make Chinese communities and services more accessible to everyone.",
      stats: {
        youtube: "YouTube Views",
        tiktok: "TikTok Followers",
        merchants: "Intended Community Partners",
      },
      problemsTitle: "Problems with Traditional Platforms",
      problems: [
        "Information overload, hard to find useful information",
        "Commerce-oriented, ignoring Chinese community needs",
        "Immigrants and underserved communities face digital divide and information access barriers",
        "Lack of education and tech literacy support for communities",
      ],
      solutionsTitle: "Our Solutions",
      solutions: [
        "AI-driven information search and educational tools for learning and daily life",
        "Community needs first, serving underserved Chinese communities and more",
        "Promote tech literacy and digital inclusion; connect community resources and information; also opens community access to all",
        "Provide education and community services to support immigrant integration and growth",
      ],
      visionTitle: "Our Vision",
      visionDesc:
        "Become the AI-powered community platform for overseas Chinese",
      stages: [
        {
          stage: "Phase 1",
          title: "Focus on NYC Chinatown/Flushing",
          desc: "Serve elders, new immigrants, and students",
        },
        {
          stage: "Phase 2",
          title: "Cover All US Chinese Communities",
          desc: "Expand to all Chinese communities in the US",
        },
        {
          stage: "Phase 3",
          title: "Serve Global Chinese",
          desc: "Become the AI smart gateway for global Chinese",
        },
      ],
      advantagesTitle: "Our Advantages",
      advantages: [
        {
          title: "AI-Driven",
          desc: "AI technology for education and information access",
        },
        {
          title: "Mission-Driven",
          desc: "Focused on community education and digital inclusion",
        },
        {
          title: "Cultural Depth",
          desc: "Deep understanding of Chinese community culture and needs",
        },
        {
          title: "Community First",
          desc: "Help immigrants and underserved communities bridge the digital divide",
        },
      ],
      whyNowTitle: "Why Now?",
      whyNowDesc:
        "Many immigrants and Chinese community members face language barriers, information access challenges, and the digital divide. We believe that through AI and educational technology, we can connect overlooked community members, promote tech literacy and community integration, and help them access information and opportunity in the digital age.",
      joinUs: "If you share the same vision and mission, welcome to join us!",
      contactTitle: "Contact Us",
      contactDesc: "We will get back to you soon.",
      sendResumeTo: "Send resume to",
    },
    agentBiPage: {
      title: "Agent BI",
      body: "Democratize Agentforce/Salesforce-like products for nonprofits and small Chinese businesses, intelligence and data for good. Humans with agents drive people success together. Leveraging open source resources like Superset and more.",
      backToProjects: "Back to Project & Research",
      videoUnsupported: "Your browser does not support playing this video.",
      videoLoadHint: "Add a video file to public/videos/ as agent-bi-demo.mp4 or agent-bi-demo.mov.",
    },
    sillyDragonPage: {
      title: "Silly Dragon",
      body: "We are developing the first-of-its-kind silicon-based life—Silly Dragon—that can actually do tasks for you. We are working hard to make this super accessible, even for people without a technical background. Long term, we are building toward highly capable AI that can help and serve the entire Chinese community—but we are starting with achievable steps. We are releasing a testing version of our AI assistant first so you can get an early taste of what is coming.",
      earlyAccessTitle: "Early access",
      earlyAccessIntro: "The early access is super accessible for non-technical users to get a taste of AI agents.",
      earlyAccessBullet1: "One-click download",
      earlyAccessBullet2: "Direct chat via Telegram, WhatsApp, more",
      earlyAccessBullet3: "View planned cron jobs in your calendar",
      earlyAccessBullet4: "Manage AI agent skills like your video game companion",
      backToProjects: "Back to Project & Research",
      videoUnsupported: "Your browser does not support playing this video.",
      videoLoadHint: "Add a video file to public/videos/ as silly-dragon-demo.mp4 (recommended) or silly-dragon-demo.mov.",
      aboutTitle: "Later versions",
      aboutSubtitle: "Silicon Dragon Egg — Silicon life hatching",
      aboutBrain: "Brain: LLMs; own model planned",
      aboutClaw: "Claw: OpenClaw for now; own dragon claw in development",
      aboutEye: "Eye: Dragon-dotting CV project launching",
      aboutEar: "Ear: Planned wearable devices like pins and rings",
      aboutBody: "Body: Seeking robotics partners and sponsorship",
      aboutVersion: "Version 0.2.1",
      download: "Download Early Access",
      downloadModalTitle: "Confirm download",
      downloadModalDetected: "We detected your device:",
      downloadModalConfirm: "Confirm download",
      downloadModalCancel: "Cancel",
      deviceMacAppleSilicon: "Mac (Apple Silicon)",
      deviceMacIntel: "Mac (Intel)",
      deviceWindows64: "Windows (64-bit)",
      deviceWindowsArm64: "Windows (ARM64)",
      deviceOther: "Other device",
      downloadOtherMessage: "Please visit our releases page for Linux or other platforms.",
    },
    forumIntroPage: {
      title: "Community Forum + AI matching",
      body: "Many traditional forum-style sites prioritize money-making and gatekeeping, locking away a lot of useful information. We're building a completely free forum where everyone can share information and help each other. We will also use AI to match you with the people you need—whether that's help, advice, a career coffee chat, or more.",
      backToProjects: "Back to Project & Research",
      goToForum: "Go to Forum",
      image1Alt: "Chinese community and AI services hub",
      image2Alt: "Forum categories",
    },
    education: {
      mvpBanner:
        "STEM MVP: computer science / AI focused minimum viable product testing at:",
      title: "Make education accessible",
      inDevelopment: "In Development",
      subtitle: "With an interactive AI teacher—quality education for everyone",
      description:
        "From beginner to advanced, we make education accessible for the Chinese community and all with an interactive AI teacher.",
      aiFeature: {
        badge: "AI Education",
        title: "Make education accessible with an interactive AI teacher",
        description:
          "Redefine learning with an interactive AI teacher. Personalized courses, smart Q&A, and real-time feedback—so every minute of learning counts.",
        cta: "Try Now",
      },
      introImageAlt: "AI Interactive Classroom and courses platform",
      popularCourses: "Popular Courses",
      foundCourses: "Found",
      courses: "courses",
      learnMore: "Learn More →",
      categories: [
        "All",
        "Language Learning",
        "Software Engineering & IT",
        "Business",
        "Data Science",
        "Service Industry",
      ],
      levels: {
        beginner: "Beginner",
        intermediate: "Intermediate",
        advanced: "Advanced",
      },
      coursesList: [
        {
          title: "English Learning",
          description:
            "From zero to fluent communication, comprehensively improve English listening, speaking, reading, and writing skills, helping new immigrants quickly adapt to American life and work.",
          category: "Language Learning",
        },
        {
          title: "Software Engineer",
          description:
            "Full-stack development skills, master frontend, backend, database and other core technologies, become a professional software engineer.",
          category: "Software Engineering & IT",
        },
        {
          title: "Data Scientist",
          description:
            "Data analysis, machine learning, AI technology, master core data science skills, become a sought-after data expert.",
          category: "Data Science",
        },
        {
          title: "Project Manager",
          description:
            "Project planning, team management, risk management and other core skills, become an excellent project manager.",
          category: "Business",
        },
        {
          title: "UX Designer",
          description:
            "User experience design, interface design, interaction design, create excellent product experiences.",
          category: "Software Engineering & IT",
        },
        {
          title: "Chef",
          description:
            "Chinese cooking techniques, Western basics, food safety, master professional culinary skills, start a catering career.",
          category: "Service Industry",
        },
        {
          title: "Accountant",
          description:
            "Financial accounting, tax planning, auditing skills, become a professional accounting talent.",
          category: "Business",
        },
        {
          title: "Data Analyst",
          description:
            "Excel, SQL, data visualization, master core data analysis tools and skills.",
          category: "Data Science",
        },
        {
          title: "Marketing/Growth",
          description:
            "Digital marketing, social media marketing, content marketing, growth strategy — master modern marketing skills.",
          category: "Business",
        },
        {
          title: "Cybersecurity",
          description:
            "Cybersecurity basics, penetration testing, security protection, become a professional cybersecurity expert.",
          category: "Software Engineering & IT",
        },
        {
          title: "Nail Technician",
          description:
            "Nail technology, care techniques, fashion design, master professional nail skills.",
          category: "Service Industry",
        },
        {
          title: "Massage Therapist",
          description:
            "Massage techniques, therapy knowledge, health care, become a professional therapist.",
          category: "Service Industry",
        },
      ],
    },
    info: {
      title: "AI Assistant",
      pageTitle: "AI Assistant",
      tagline: "One command for any task—search, chat, and create and more.",
      categories: [
        "All",
        "Search Assistant",
        "Content Generation",
        "Data Analysis",
        "Life Assistant",
        "Productivity Tools",
      ],
      inDevelopment: "In Development",
      searchPlaceholder: "What would you like to do? Tell me your needs...",
      servicesTitle: "What can I do for you?",
      servicesSubtitle:
        "Select the AI function you need, or describe your needs directly in the search box",
      bottomTitle: "Less Structure, More Intelligence",
      bottomDesc:
        "No complex operations needed—just tell AI what you want and we’ll help you get it done.",
      services: {
        aiSearch: {
          title: "AI Smart Search",
          description:
            "Precise information search, quickly find what you need, say goodbye to information overload.",
          category: "Search Assistant",
        },
        aiChat: {
          title: "AI Chat Assistant",
          description:
            "One command to complete various tasks, answer any questions, like a smart assistant by your side.",
          category: "Search Assistant",
        },
        docTranslate: {
          title: "Document Translation",
          description:
            "Translate documents into any language, preserve format and tone, support bilingual translation.",
          category: "Content Generation",
        },
        resume: {
          title: "Resume Writing",
          description:
            "Help you write professional resumes, CVs, and cover letters to boost your job search.",
          category: "Productivity Tools",
        },
        emailWrite: {
          title: "Email Writing",
          description:
            "Write formal, professional business emails for various occasions and scenarios.",
          category: "Productivity Tools",
        },
        dataOrg: {
          title: "Data Organization",
          description:
            "Turn messy data into clear, structured tables for easy analysis and use.",
          category: "Data Analysis",
        },
        bilingual: {
          title: "Bilingual Output",
          description:
            "Get side-by-side bilingual text, with support for any two languages.",
          category: "Content Generation",
        },
        calcTool: {
          title: "Custom Calculator Tools",
          description:
            "Create professional online tools like custom calculators and unit converters.",
          category: "Data Analysis",
        },
        calendarRemind: {
          title: "Calendar & Reminders",
          description:
            "Set automatic meeting reminders, connect Google Calendar, never miss important events.",
          category: "Life Assistant",
        },
        imageProcess: {
          title: "AI Image Processing",
          description:
            "Edit images easily—remove background, improve quality, apply various effects.",
          category: "Content Generation",
        },
        codeGen: {
          title: "Code Generation",
          description:
            "Generate code from requirements, support multiple languages and frameworks.",
          category: "Productivity Tools",
        },
        design: {
          title: "Design Assistant",
          description:
            "Create mockups, presentations, website prototypes, and other design tasks.",
          category: "Content Generation",
        },
        localization: {
          title: "Content Localization",
          description:
            "Adapt content for new markets with cultural and language localization.",
          category: "Content Generation",
        },
        communityQA: {
          title: "Community Q&A",
          description:
            "Answer questions about the Chinese community—life, work, study, and more.",
          category: "Life Assistant",
        },
        jobAssistant: {
          title: "Job Assistant",
          description:
            "Job search advice, interview prep, salary negotiation, and career development help.",
          category: "Productivity Tools",
        },
        dataExport: {
          title: "Data Export",
          description:
            "Extract key information from documents and organize it into structured tables.",
          category: "Data Analysis",
        },
        copyEdit: {
          title: "Copy Editing",
          description:
            "Improve and refine text for clarity, style, and impact.",
          category: "Content Generation",
        },
        customerService: {
          title: "Customer Service Assistant",
          description:
            "Auto-reply to customer inquiries, handle common questions, improve service efficiency.",
          category: "Productivity Tools",
        },
        more: {
          title: "More Services",
          description: "More AI services are under development, stay tuned...",
          category: "",
        },
      },
    },
    aiEducation: {
      title: "AI Interactive Classroom",
      inDevelopment: "In Development",
      brandName: "AI Education",
      searchPlaceholder: "Search courses...",
      create: "Create",
      login: "Log in",
      sidebarHome: "Home",
      sidebarBookmark: "Saved",
      sidebarHistory: "History",
      sidebarCourses: "Courses",
      sidebarSubscribe: "Subscribe",
      sidebarSettings: "Settings",
      sidebarStudio: "Studio",
      backToEducation: "Back to Education",
      heroSubline:
        "Move beyond static videos—keep a clear curriculum and interact with your instructor anytime.",
      pasteVideoPrompt: "Paste a video link or describe your video",
      coursesTitle: "Courses",
      viewDetails: "View details",
      lessonsCount: "{n} lessons",
      updatedAt: "Updated {time}",
      noCoursesFound: "No courses found",
      levelBeginner: "Beginner",
      levelIntermediate: "Intermediate",
      levelAdvanced: "Advanced",
      courses: [
        {
          title: "AI-Powered English Learning",
          description:
            "From zero to fluent—AI evaluates your pronunciation and grammar and gives you personalized practice.",
          level: "levelBeginner",
          duration: "8 wk",
          lessons: "8",
          category: "Language",
          instructor: "Instructor",
          updated: "1 day ago",
        },
        {
          title: "AI Coding Assistant Course",
          description:
            "Learn how to use AI tools to code faster and master modern software development.",
          level: "levelIntermediate",
          duration: "12 wk",
          lessons: "12",
          category: "Tech",
          instructor: "Instructor",
          updated: "2 days ago",
        },
        {
          title: "AI Data Analysis in Practice",
          description:
            "Use AI for data analysis and visualization and make data-driven decisions.",
          level: "levelAdvanced",
          duration: "10 wk",
          lessons: "10",
          category: "Data Science",
          instructor: "Instructor",
          updated: "3 days ago",
        },
        {
          title: "AI in the Workplace",
          description:
            "See how AI is used at work and learn to boost productivity and career skills.",
          level: "levelIntermediate",
          duration: "6 wk",
          lessons: "6",
          category: "Career",
          instructor: "Instructor",
          updated: "1 wk ago",
        },
        {
          title: "AI Content Creation",
          description:
            "Master AI-assisted writing, design, and content creation for better creative output.",
          level: "levelBeginner",
          duration: "4 wk",
          lessons: "4",
          category: "Creative",
          instructor: "Instructor",
          updated: "5 days ago",
        },
        {
          title: "AI Career Planning",
          description:
            "AI analyzes your skills and interests and suggests the best career path for you.",
          level: "levelBeginner",
          duration: "2 wk",
          lessons: "2",
          category: "Career",
          instructor: "Instructor",
          updated: "1 day ago",
        },
      ],
    },
    shopping: {
      title: "Find Local Businesses",
      categories: [
        "All",
        "Food & Dining",
        "Daily Goods",
        "Fresh Produce",
        "Clothing & Shoes",
        "Electronics",
        "Home Goods",
        "Beauty & Care",
      ],
      delivery: "Delivery",
      addToCart: "Add to Cart",
      searchPlaceholder: "Search products, merchants...",
      filter: "Filters",
      categoryTitle: "Product Categories",
      foundProducts: "Found {count} products",
      sort: {
        newest: "Newest",
        priceLow: "Price: Low to High",
        priceHigh: "Price: High to Low",
        rating: "Highest Rating",
        sales: "Best Selling",
      },
      inDevelopment: "In Development",
    },
    hr: {
      people: "People",
      teamMembersDeptsRoles: "team members · departments · open roles",
      myProfile: "My Profile",
      addPerson: "Add Person",
      demoBanner:
        "Demo data — Connect the backend API to manage real records. You can explore the UI with this sample data.",
      overview: "Overview",
      attendance: "Attendance",
      analytics: "Analytics",
      directory: "Directory",
      orgChart: "Org Chart",
      reviews: "Reviews",
      benefits: "Benefits",
      ptoPolicy: "PTO Policy",
      positions: "Positions",
      auditLog: "Audit Log",
      totalPeople: "Total People",
      fullTime: "Full-time",
      partTime: "Part-time",
      interns: "Interns",
      onLeaveToday: "On leave today",
      departments: "Departments",
      addDepartment: "Add Department",
      teamMembers: "Team Members",
      viewAll: "View all",
      upcomingLeave: "Upcoming leave",
      companyHolidays: "Company holidays",
      announcements: "Announcements",
      myTeam: "My team",
      noUpcomingLeave: "No upcoming leave in the next 14 days",
      noAnnouncements: "No announcements yet",
      noPeopleYet: "No people yet",
      noPeopleFound: "No people found",
      tryAdjustFilters: "Try adjusting your filters",
      attendanceDesc:
        "Leave and absences are part of attendance. Approved leave for the day shows as Leave.",
      clockIn: "Clock in",
      clockOut: "Clock out",
      name: "Name",
      status: "Status",
      clockInCol: "Clock in",
      clockOutCol: "Clock out",
      noAttendanceData: "No attendance data for this date",
      statusActive: "Active",
      statusOnLeave: "On leave today",
      statusOffboarded: "Offboarded",
      typeFullTime: "Full-time",
      typePartTime: "Part-time",
      typeVolunteer: "Volunteer",
      typeIntern: "Intern",
      typeContractor: "Contractor",
      attPresent: "Present",
      attLeave: "Leave",
      attAbsent: "Absent",
      attLate: "Late",
      attWfh: "WFH",
      attBusinessTrip: "Business trip",
      leaveVacation: "Vacation",
      leaveSick: "Sick",
      leavePersonal: "Personal",
      leaveOther: "Other",
      allStatus: "All Status",
      allDepartments: "All Departments",
      allTypes: "All Types",
      searchPlaceholder: "Search name or email...",
      exportCSV: "Export CSV",
      export: "Export",
      selected: "selected",
      importCSV: "Import CSV",
      bulkActions: "Bulk actions",
      changeStatus: "Change status...",
      offboard: "Offboard",
      clear: "Clear",
      pageOf: "Page {page}/{pages} · {total} total",
      addDepartmentTitle: "Add Department",
      editDepartment: "Edit Department",
      editPosition: "Edit Position",
      addPersonTitle: "Add Person",
      addPosition: "Add Position",
      editPerson: "Edit Person",
      edit: "Edit",
      displayName: "Display Name",
      email: "Email",
      firstName: "First Name",
      lastName: "Last Name",
      department: "Department",
      position: "Position",
      manager: "Manager",
      employmentType: "Employment Type",
      startDate: "Start Date",
      endDate: "End Date",
      phone: "Phone",
      notes: "Notes",
      description: "Description",
      emergencyContact: "Emergency Contact",
      salary: "Salary",
      compBand: "Comp Band",
      equity: "Equity",
      ptoAccrued: "PTO Accrued (hours)",
      cancel: "Cancel",
      save: "Save",
      post: "Post",
      noNotifications: "No notifications",
      notifications: "Notifications",
      addPlan: "Add plan",
      addCycle: "Add cycle",
      addReview: "Add review",
      addCycleTitle: "Add review cycle",
      addReviewTitle: "Add performance review",
      editReviewTitle: "Edit review",
      selfReview: "Self review",
      managerFeedback: "Manager feedback",
      rating: "Rating",
      cycle: "Cycle",
      reviewCycles: "review cycles",
      employee: "Employee",
      draft: "Draft",
      selfSubmitted: "Self submitted",
      managerSubmitted: "Manager submitted",
      completed: "Completed",
      meets: "Meets",
      exceeds: "Exceeds",
      below: "Below",
      noRating: "No rating",
      addBenefitPlan: "Add benefit plan",
      addPTOPolicy: "Add PTO policy",
      runAccrual: "Run accrual",
      headcountByDept: "Headcount by department",
      tenureDistribution: "Tenure distribution",
      active: "Active",
      inactive: "Inactive",
      avgTenureMonths: "Avg tenure (months)",
      attrition12m: "12m attrition",
      benefitPlans: "Benefit plans",
      ptoPolicies: "PTO accrual policies",
      auditEntries: "entries",
      noBenefitPlans: "No benefit plans yet",
      noPtoPolicies: "No PTO accrual policies yet",
      noAuditEntries: "No audit entries yet",
      noPositionsYet: "No positions yet",
      noCyclesYet: "No cycles yet",
      selectCycle: "Select a cycle",
      noReviewsInCycle: "No reviews in this cycle",
      internalNotes: "Internal notes (not visible to employee)",
      noPosition: "No position",
      unassigned: "Unassigned",
      addLeave: "Add leave",
      leave: "Leave",
      leavePending: "Leave pending",
      addGoal: "Add goal",
      goals: "Goals",
      compensation: "Compensation",
      compensationHistory: "Compensation history",
      dependents: "Dependents",
      onboardingTasks: "Onboarding tasks",
      offboardingTasks: "Offboarding tasks",
      documents: "Documents",
      oneOnOneNotes: "1:1 notes",
      toastOffboarded: "Offboarded",
      toastCsvExported: "CSV exported",
      toastPunchedIn: "Punched in",
      toastPunchedOut: "Punched out",
      toastPunchInFailed: "Punch in failed",
      toastPunchOutFailed: "Punch out failed",
      toastLeaveApproved: "Leave approved",
      toastLeaveDenied: "Leave denied",
      toastSaved: "Saved",
      toastImportDone: "Import done: {ok} added, {err} failed",
      toastAccrualRun: "Accrual: {updated} updated, {skipped} skipped",
      toastCsvInvalid: "CSV must include headers and at least one row",
      toastExported: "Exported {count} people",
      toastUpdated: "Updated {count} to {status}",
      deptEngineering: "Engineering",
      deptProduct: "Product",
      deptMarketing: "Marketing/Growth",
      deptOperations: "Operations",
      deptCommunity: "Community",
      title: "Internal People Management",
      subtitle: "Add and remove people, assign positions. Internal use only.",
      namePlaceholder: "Enter name",
      selectPosition: "Select position",
      positionPlaceholder: "Type or choose position",
      positionOptions: [
        "Software Engineer",
        "Backend Engineer",
        "Frontend Engineer",
        "Product Manager",
        "Community Operations",
        "Designer",
        "Volunteer",
        "Other",
      ],
      emailPlaceholder: "Optional",
      add: "Add",
      peopleList: "People",
      actions: "Actions",
      remove: "Remove",
      confirmRemove: "Remove this person?",
      noPeople: "No people yet",
      noPeopleHint: "Use the form above to add people.",
      internalOnly: "Internal use only · Data stored in browser",
    },
    footer: {
      about: {
        title: "About Us",
        platform: "Platform Overview",
        mission: "Our Mission",
        contact: "Contact Us",
        teams: "Teams",
        join: "Join Us",
      },
      services: {
        title: "Core Services",
        other: "Other Services",
      },
      moreServices: {
        title: "More Services",
      },
      follow: {
        title: "Follow Us",
      },
      copyright: "© {year} Chinese Community AI. All rights reserved.",
      tagline: {
        vision: "AI-powered community platform for overseas Chinese",
        mission: "Nonprofit, giving back to the community",
      },
    },
    wiki: {
      title: "CCAI Wiki",
      backToSite: "chinesecommunity.ai",
      allWiki: "All Wiki",
      searchPlaceholder: "Search Wiki...",
      searchDialog: "Search Wiki",
      noResults: "No results",
      navLabel: "Navigation",
      home: "Home",
      search: "Search",
      glossary: "Glossary",
      myDrafts: "My Drafts",
      communityPages: "Community Pages",
      newPage: "New Page",
      reviewQueue: "Review Queue",
      readOnly: "Read-only",
      lastUpdated: "Last updated",
      reviewBy: "Review by",
      ownerTitle: "Page owner",
      fallbackBanner:
        "Chinese translation for this page is in progress. English content is shown below. Add zh markdown under content/wiki/zh/ via PR.",
      notFoundTitle: "Page not found",
      notFoundDesc: "This wiki page does not exist.",
      backHome: "Back to wiki home",
      searchTitle: "Search",
      searchIntro: "Use the search bar above or press ⌘K. {count} pages indexed.",
      searchInputPlaceholder: "Search...",
      noResultsFor: 'No results for "{q}"',
      status: {
        stable: "Stable",
        draft: "Draft",
        deprecated: "Deprecated",
      },
    },
    placeholder: {
      defaultDesc: "This page is under development. Stay tuned!",
      delivery: {
        name: "Find Local Businesses",
        description:
          "Discover and connect with local Chinese businesses; shop and get delivery in one place.",
      },
      streaming: {
        name: "Media Content",
        description:
          "Rich cultural content including short videos and documentaries, promoting Chinese culture.",
      },
      contact: {
        name: "Contact Us",
        description:
          "We welcome your feedback and suggestions. Let's build a better Chinese community platform together.",
      },
      forum: {
        name: "Information",
        description: "This feature has been integrated into Information.",
      },
      offers: {
        name: "Admissions",
        description: "This feature has been integrated into Education.",
      },
      jobs: {
        name: "Jobs",
        description: "This feature has been integrated into Education.",
      },
      visa: {
        name: "Visa & Immigration",
        description: "This feature has been integrated into Legal Help.",
      },
      salary: {
        name: "Salary Data",
        description: "This feature has been integrated into Education.",
      },
      notFound: { name: "404 - Page Not Found", description: "" },
    },
  },
};
